import React, { useEffect, useState, useRef } from "react";
// import { Layout, Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
//
// import { FetchLandingPageAction } from "../../../redux/action/LandingPageAction";
// import { getOktaAuth, getOktaUserClaims } from "../../../utils/okta/okta-auth";
import { useAuth } from "../../utils/auth/useAuth";
import { LoadingSpinner, Switcher, TabsNavigation, Tab, Card, Sidepanel, Button, Tag, Tooltip, Icon, Notification } from "pepsico-ds";
import { Outlet, useNavigate } from "react-router-dom";
// import CommodityCard from "../../../components/Cards/CommodityCard";
// import Fastmarkets from '../../../assets/Fastmarkets.svg'
// import Smartcube from '../../../assets/Smartcube.svg'
// import MinTec from '../../../assets/MinTec.svg'
// import { localStoreKeys } from '../../../constants/localStoreKeys';
// import { setKeyValue } from "../../../redux/reducer/localDataSlice";
// import { FetchCommodityLandingAction } from "../../../redux/action/RISIAction";
import ExImBanner from '../../assets/ExImBanner.svg'
import Procure360 from '../../assets/Procure360.svg'
import Procure_Logo_360 from '../../assets/Procure_Logo_360.svg'
import ExImLogo from '../../assets/ExImLogo.svg'
import Trade_ShowResources_btn from '../../assets/Trade_ShowResources_btn.svg'
import CommodityPageHeader from "../../components/Header/CommodityPageHeader";
import SpendDonutChart from "../../components/Charts/SpendAnalyticsChart/SpendDonutChart";
import NoData from "../../components/NoData/NoData";
import LegendList from "../../components/Charts/Legend/LegendList";
import TrendAnalyticsLineBarChart from "../../components/Charts/TrendAnalyticsChart/TrendAnalyticsLineBarChart";
import TradAnalyticsSidePanel from "./TradAnalyticsSidePanel";
import { changeFromDateOptionsUtil, changeToDateOptionsUtil } from "../KPIOverview/KpiUtils";



// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useAuth } from "../../utils/auth/useAuth";
import { FetchLandingPageAction } from "../../redux/action/LandingPageAction";
import { getUserClaims } from "../../utils/auth/unified-auth";
import { setKeyValue } from "../../redux/reducer/localDataSlice";
import { localStoreKeys } from "../../constants/localStoreKeys";
import SingleSelectDropdown from "../../components/Dropdown/SingleSelectDropdown";
import MultiSelectDropdown from "../../components/Dropdown/MultiSelectDropdown";
import { Col, message, Row } from 'antd';
import { FetchImarcDetailAction, FetchImarcDropdownAction, FetchImarcSecondaryDropdownAction } from "../../redux/action/ImarcAction";
import { getBUsForSupplierFilters, getGradeOptions, getImportingCountries, getSectorsForSupplierFilters, getSizeOptions, getTradeNameOptions, getTypeOptions, getYears, getCategoriesLevel1, getCategoriesLevel2, getBusinessUnitsBySector, getCategoriesBySectorAndBusinessUnit, getRoles, getCategoriesL0ForSupplierFilters, getCategoriesL1ForSupplierFilters, getL2OptionsExIm, getCategoriesL2ForExImFilters, getFilterModeValues, getSectors } from "../KPIOverview/KpiUtils";
import { getMonthsWithYearRangeAdjustedForMaxDate, getMonthsWithYearWithMaxDate, getToDateOptionsWithMaxDate, getToDateOptions, formatNumberWithCommas, getBNMNOrKValue, getOverlappingOptionsV2, call7DaysNpsLogic } from "../../utils/utils";
import reset_icon from "../../../src/assets/reset_icon.svg";
import Vector from '../../../src/assets/Vector.png'
import DropdownWithIcons from "../../components/Modal/DropdownWithIcons";
import { useToast } from "../../components/Toast/ToastContext";
import { splitValueWithUnit } from "../../utils/utils";
import { FetchExImCountryReportAction, FetchExImDropdownAction, FetchExImMonthlyReportAction, FetchExImSecondaryDropdownAction } from "../../redux/action/ExImAction";
import InfoIcon from "../../components/Icons/InfoIcon";
import { useLoginEffects } from "../WalkmeTour/UseLoginEffects";

const MIN_IMARC_YEAR = 2023;
const MIN_EXIM_YEAR = 2023;
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const date = new Date();
const currentYear = date.getFullYear();
const DEFAULT_FROM_DATE_YEAR = currentYear-1;
const DEFAULT_TO_DATE_YEAR = currentYear+1;
const DEFAULT_FROM_DATE = "Jan "+DEFAULT_FROM_DATE_YEAR;
const DEFAULT_TO_DATE = "Dec "+DEFAULT_TO_DATE_YEAR;

const DEFAULT_IMARC_L0 = [{id: 1, displayText: "GP DIRECTS"}]
const DEFAULT_IMARC_L1 = [{id: 1, displayText: "PACKAGING"}]
function TradeAnalyticsLanding() {
    const navigate = useNavigate();
    const [selectedTab, setSelectedTab] = useState(1)
    const [switcherIndex, setSwitcherIndex] = useState(0)
   
    const [showSidePanel, setShowSidePanel] = useState(false)
    
    const [trendAnalyticsLineBarChartData, settrendAnalyticsLineBarChartData] = useState([])
	const userData = useSelector((state) => state.getLandingPageReducer);

    useLoginEffects(userData)
    

    const dispatch = useDispatch();
	const { authState, authInstance } = useAuth();
	const [userInfo, setUserInfo] = useState({});
    const [isUserDataFetched, setIsUserDataFetched] = useState(false)
    const [isDataLoading, setIsDataLoading] = useState(false);


    const [isExImDataLoading, setIsExImDataLoading] = useState(false);
    const [isExImMonthPart1DataLoading, setIsExImMonthPart1DataLoading] = useState(false);
    const [isExImYearPart2DataLoading, setIsExImYearPart2DataLoading] = useState(false);

    
    const [dropdownExImValues, setExImDropdownValues] = useState({})
    const [roleExImSelected, setRoleExImSelected] = useState([])
    const [userL1, setUserL1] = useState([])
    const [userL2, setUserL2] = useState([])
    
    const [allCategoryL0, setAllCategoryL0] = useState([])
    const [categoryL0ExImSelected, setCategoryL0ExImSelected] = useState([])
    const [categoryL1ExImSelected, setCategoryL1ExImSelected] = useState([])
    const [categoryL2ExImSelected, setCategoryL2ExImSelected] = useState([])
    const [categoriesExImLevel0, setCategoriesExImLevel0] = useState([])
    const [categoriesExImLevel1, setCategoriesExImLevel1] = useState([])
    const [categoriesExImLevel2, setCategoriesExImLevel2] = useState([])

    
    const [exImswitcherIndex, setexImSwitcherIndex] = useState(0)
    const [countryexImSwitcherIndex, setCountryexImSwitcherIndex] = useState(0)
    const [isDefaultExImChanged, setIsDefaultExImChanged] = useState(false)
    const [exImCurrentFilterModeKey, setExImCurrentFilterModeKey] = useState("productDescription")
    const [hsCodes, setHsCodes] = useState([])
    const [hsCodeSelected, setHsCodeSelected] = useState([])
    const [productDescriptions, setProductDescriptions] = useState([])
    const [productDescriptionSelected, setProductDescriptionSelected] = useState([])

    const [exImfromDates, setExImFromDates] = useState([])
    const [exImtoDates, setExImToDates] = useState([])
    const [fromDateExImSelected, setFromDateExImSelected] = useState("")
    const [toDateExImSelected, setToDateExImSelected] = useState("")
    const [exImentireMonthList, setExImEntireMonthList] = useState([])

    const [exImimportingCountries, setExImImportingCountries] = useState([])
    const [importingExImYears, setImportingExImYears] = useState([])
    const [exportingExImCountries, setExportingExImCountries] = useState([])
    const [exportingExImYears, setExportingExImYears] = useState([])

    const [importingCountryExImSelected, setImportingCountryExImSelected] = useState([])
    const [importingExImYearSelected, setImportingExImYearSelected] = useState([])
    const [exportingCountryExImSelected, setExportingCountryExImSelected] = useState([])
    const [exportingYearExImSelected, setExportingYearExImSelected] = useState([])


    const [exIMswitcherLineBarChartIndex, setExIMswitcherLineBarChartIndex] = useState(0)
    const [exIMswitcherPieChartIndex, setExIMswitcherPieChartIndex] = useState(0)
    const [exIMswitcherByCountryLineBarChartIndex, setExIMswitcherByCountryLineBarChart] = useState(0)
    const [showExImSidePanel, setShowExImSidePanel] = useState(false)
    const [exImMonthtrendAnalyticsLineBarChartData, setexImMonthtrendAnalyticsLineBarChartData] = useState([])
    const [exImYeartrendAnalyticsLineBarChartData, setexImYeartrendAnalyticsLineBarChartData] = useState([])
    const [hsCodeMapping, setHsCodeMapping] = useState([])
    const [currentTooltipText, setCurrentTooltipText] = useState("")



    
    const [dropdownValues, setDropdownValues] = useState({})
    const [secondaryDropdownValues, setSecondaryDropdownValues] = useState({})
    const [roleSelected, setRoleSelected] = useState([])
    const [materials, setMaterials] = useState([])
    const [materialSelected, setMaterialSelected] = useState([])
    const [allMaterials, setAllMaterials] = useState([])
    const [grades, setGrades] = useState([])
    const [gradeSelected, setGradeSelected] = useState([])
    const [materialTypes, setMaterialTypes] = useState([])
    const [materialTypeSelected, setMaterialTypeSelected] = useState([])
    const [tradeNames, setTradeNames] = useState([])
    const [tradeNameSelected, setTradeNameSelected] = useState([])
    const [sizeOptions, setSizeOptions] = useState([])
    const [sizeOptionSelected, setSizeOptionSelected] = useState([])
    const [exportingCountries, setExportingCountries] = useState([])
    const [exportingCountrySelected, setExportingCountrySelected] = useState([])
    const [importingCountries, setImportingCountries] = useState([])
    const [importingCountrySelected, setImportingCountrySelected] = useState([])

    
    const [categoryL0Selected, setCategoryL0Selected] = useState([])
    const [categoryL1Selected, setCategoryL1Selected] = useState([])
    const [fromDates, setFromDates] = useState([])
    const [toDates, setToDates] = useState([])
    const [fromDateSelected, setFromDateSelected] = useState("")
    const [toDateSelected, setToDateSelected] = useState("")
    const [entireMonthList, setEntireMonthList] = useState([])

    const TrendforVolumeandOverallValueRef = useRef()
    const VolumeSharebyImportCountryRef = useRef()
    const OverallValueSharebyExportCountryRef = useRef()
    const VolumeSharebyExportCountryRef = useRef()
    const OverallValueSharebyImportCountryRef = useRef()


    const exImMonthTrendforVolumeandOverallValueRef = useRef()
    const exImVolumeSharebyImportCountryRef = useRef()
    const exImOverallValueSharebyExportCountryRef = useRef()
    const exImVolumeSharebyExportCountryRef = useRef()
    const exImOverallValueSharebyImportCountryRef = useRef()
    const exImYearTrendforVolumeandOverallValueRef = useRef()

    const feedbackFormUrl = useSelector((state) => state?.localData?.data[localStoreKeys.feedbackFormUrl]);

    // useEffect(() => {
	// 	async function fetchUserInfo() {
	// 		const user = await getOktaUserClaims(getOktaAuth());
	// 		setUserInfo(user);
	// 		dispatch(FetchLandingPageAction(user));
    //         setIsUserDataFetched(true)
	// 	}
    //     setIsExImDataLoading(true)
	// 	fetchUserInfo();
	// }, []);


	const primaryDropdownExImData = useSelector((state) => state.getExImDropdownReducer);
	const secondaryDropdownExImData = useSelector((state) => state.getExImSecondaryDropdownReducer);

    const exImMonthlyData = useSelector((state) => state.getExImMonthlyReportReducer);
    const exImCountryData = useSelector((state) => state.getExImCountryReportReducer);

    

    /* istanbul ignore next */
    useEffect(() => {
        if (isUserDataFetched && userData && userData.type === "SUCCESS_LANDING_PAGE_ACTION") {


            // dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: false }))
            // // 7 days NPS logic
            // const now = Date.now(); // current timestamp in milliseconds

            // const responseDate = new Date(userData?.mostRecentDate).getTime(); // convert to timestamp in ms

            // const diffInMs = Math.abs(now - responseDate); // difference in milliseconds

            // const daysDiff = diffInMs / (1000 * 60 * 60 * 24); // convert ms to days

            // if (daysDiff >= 7) {
            //     dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: false }))
            // } else {
            //     dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: true }))
            // }

            // setIsExImDataLoading(true)

            call7DaysNpsLogic(dispatch, userData)
            const Roles = getRoles(userData?.details)
            const defaultRole = Roles.filter(item => item.displayText === userData?.defaultRole)
            setRoleExImSelected([{ id: 1, displayText: userData?.defaultRole}]);
            const getUserInfoByRole = userData?.details?.filter(item => item.role === defaultRole[0]?.displayText)?.[0]
            const sectors = getSectors(getUserInfoByRole?.roleDetail);
            let sectorsToInclude = sectors?.map(item => (item.displayText))
            const BUs = getBusinessUnitsBySector(getUserInfoByRole?.roleDetail, sectorsToInclude);
            let businessUnitsToInclude = BUs?.map(item => (item.displayText))
            
            const tempCategories = getCategoriesBySectorAndBusinessUnit(getUserInfoByRole?.roleDetail, sectorsToInclude, businessUnitsToInclude)
            let categoriesToInclude = tempCategories.map(item => (item.displayText))
            const tempCategoriesLevel1 = getCategoriesLevel1(getUserInfoByRole?.roleDetail, categoriesToInclude, sectorsToInclude, businessUnitsToInclude);
            let categoriesL1ToInclude = tempCategoriesLevel1.map(item => (item.displayText))
            const tempCategoriesLevel2 = getCategoriesLevel2(getUserInfoByRole?.roleDetail, categoriesToInclude, categoriesL1ToInclude, sectorsToInclude, businessUnitsToInclude, "");
            let categoriesL2ToInclude = tempCategoriesLevel2.map(item => (item.displayText)) 
            localStorage.setItem('isDefaultChanged_exIm', 0) 
            localStorage.setItem('exim_current_country_switch', 0) 
            dispatch(FetchExImDropdownAction({role:defaultRole[0]?.displayText, l0:categoriesToInclude, l1:categoriesL1ToInclude, l2:categoriesL2ToInclude})); 
        }
		
    }, [userData])

    /* istanbul ignore next */
    function getHSCodeDescription(data, selectedHSCodeText, selectedProductDescriptionText, key) {
        const match = data.find(item => {
            if (key === 'hsCode') {
                return item.hsCode === selectedHSCodeText;
            } else if (key === 'productDescription') {
                return item.productDescription === selectedProductDescriptionText;
            }
            return false;
        });
    
        return match ? match.hsCodeDescription : null;
    }
	
    /* istanbul ignore next */
    useEffect(() => {
        
        if (isUserDataFetched && primaryDropdownExImData && primaryDropdownExImData.type === "SUCCESS_EXIM_DROPDOWN_ACTION") {
            const dropdownData = primaryDropdownExImData;
            setExImDropdownValues(dropdownData);

            const l0Categories = getCategoriesL0ForSupplierFilters(primaryDropdownExImData?.l0); 
            let categoriesL0ToInclude = l0Categories?.map(item => (item.displayText));
            setCategoriesExImLevel0(l0Categories)
            setCategoryL0ExImSelected(l0Categories)
            setAllCategoryL0(l0Categories)
            localStorage.setItem('categoryL0Selected_exIm', JSON.stringify(l0Categories))

            const l1Categories = getCategoriesL1ForSupplierFilters(primaryDropdownExImData?.l0, categoriesL0ToInclude)           
            setCategoryL1ExImSelected(l1Categories)
            setCategoriesExImLevel1(l1Categories)
            localStorage.setItem('categoryL1Selected_exIm', JSON.stringify(l1Categories))
            let categoriesL1ToInclude = l1Categories?.map(item => (item.displayText));
            

            const l2Categories = getCategoriesL2ForExImFilters(primaryDropdownExImData?.l0, categoriesL0ToInclude, categoriesL1ToInclude) 
            setCategoryL2ExImSelected(l2Categories)
            setCategoriesExImLevel2(l2Categories)
            localStorage.setItem('categoryL2Selected_exIm', JSON.stringify(l2Categories))
            let categoriesL2ToInclude = l2Categories?.map(item => (item.displayText));
            
            const hsCodesStrings = (getFilterModeValues(primaryDropdownExImData?.l0, categoriesL0ToInclude, categoriesL1ToInclude, categoriesL2ToInclude, "hsCode" )).sort((a, b) => a.localeCompare(b))
            const hsCodes = hsCodesStrings?.map((item, index) => ({ displayText: item, id: index + 1 }))
            const hsCodeSelected = getOverlappingOptionsV2(hsCodes,[primaryDropdownExImData?.defaultHSCode])
            setHsCodes(hsCodes)
            setHsCodeSelected(hsCodeSelected)
            localStorage.setItem('hsCodes_exIm', JSON.stringify(hsCodes))
            localStorage.setItem('hsCodeSelected_exIm', JSON.stringify(hsCodeSelected))

            const productDescriptionStrings = (getFilterModeValues(primaryDropdownExImData?.l0, categoriesL0ToInclude, categoriesL1ToInclude, categoriesL2ToInclude, "productDescription" )).sort((a, b) => a.localeCompare(b))
            const productDescriptions = productDescriptionStrings?.map((item, index) => ({ displayText: item, id: index + 1 }))
            const productDescriptionSelected = getOverlappingOptionsV2(productDescriptions,[primaryDropdownExImData?.defaultProductDescription])
            setProductDescriptionSelected(productDescriptionSelected)
            setProductDescriptions(productDescriptions)
            localStorage.setItem('descriptions_exIm', JSON.stringify(productDescriptions))
            localStorage.setItem('descriptionSelected_exIm', JSON.stringify(productDescriptionSelected))

            setHsCodeMapping(primaryDropdownExImData?.hsCodeDescMapping || [])
            setCurrentTooltipText(getHSCodeDescription(primaryDropdownExImData?.hsCodeDescMapping, primaryDropdownExImData?.defaultHSCode, primaryDropdownExImData?.defaultProductDescription, exImswitcherIndex==0?"productDescription":"hsCode"  ))

            const dateObject = {
                appName: "ExIm",
                maxDate: primaryDropdownExImData?.dateDetail?.maxDate,
                maxYearMonth: primaryDropdownExImData?.dateDetail?.maxYearMonth,
            }
            let capabilitySearchKey = "ExIm";
            const maxDateForApps = [dateObject];
            
            const maxDateObject = maxDateForApps?.find(item => item?.appName === capabilitySearchKey);

            let yearsArray = [];
            let maxYearValue;            
            let maxYearMonth = maxDateObject?.maxYearMonth; // Example: "OCT 2024"
            
            if (maxYearMonth) {
                const [maxMonthText, maxYearText] = maxYearMonth.split(" ");
                maxYearValue = parseInt(maxYearText, 10);
            }
            
            for (let i = MIN_EXIM_YEAR; i <= maxYearValue; i++) {
                yearsArray.push(i);
            }

            const allYears = getYears(yearsArray);
            const minYr = allYears[0]?.displayText;
            const minYear = Number(minYr);

            const maxYr = allYears[allYears.length - 1]?.displayText;           
            const maxYear = Number(maxYr);
           
            

            setExImEntireMonthList(getMonthsWithYearRangeAdjustedForMaxDate(minYear, maxYear, capabilitySearchKey, maxDateForApps));

            let years = dropdownData?.year?.slice();
            
            const fromDate = getMonthsWithYearWithMaxDate(allYears, maxDateObject);
            setExImFromDates(fromDate);

            let objectYear = Number(maxDateObject?.maxDate?.split("-")[0]); // Extracting year from maxDate
            const yearSelected = (objectYear-1); // DEFAULT_FROM_DATE_YEAR // defaultYear;

            const date2 = new Date();
            const date2Year = date2.getFullYear();

            // const fromDateMonth = 'Jan';
            const fromDateMonth = (maxDateObject?.maxYearMonth?.split(" ")?.[0]);
            
            const tempFromDate = fromDate.filter((item) => {
                return item.displayText === (fromDateMonth + ' ' + yearSelected);
            })
            
            let tempToDate = fromDate.filter((item) => {
                let temp = fromDate[fromDate.length - 1]?.displayText;

                let currentLastMonth = Number(yearSelected) < objectYear
                    ? "Dec " + yearSelected
                    : maxYearMonth;

                return item.displayText.toUpperCase() === currentLastMonth.toUpperCase();
            });

            const toDateOptions = getToDateOptionsWithMaxDate(tempFromDate?.[0]?.['displayText'], maxDateObject);
            setExImToDates(toDateOptions);
            
            const defaultToDateOption = toDateOptions.filter(item=>item.displayText==DEFAULT_TO_DATE)
            if(defaultToDateOption && defaultToDateOption.length>0) {
                tempToDate = defaultToDateOption;
            } else {
                tempToDate = [toDateOptions[toDateOptions.length-1]];
            }

            setFromDateExImSelected(tempFromDate);

            localStorage.setItem('fromDateSelected_exIm', JSON.stringify(tempFromDate))

            setToDateExImSelected(tempToDate); 
            localStorage.setItem('toDateSelected_exIm', JSON.stringify(tempToDate))
            const index = fromDate.findIndex((item) => item.displayText === tempToDate[0]?.displayText);
            if (index !== -1) {
                const tempFromDates = fromDate.slice(0, index + 1);
                setExImFromDates(tempFromDates);
            }
            


            if(selectedTab == 2){
                loadsecondaryDropdownExImData()
            }
            

        }
    }, [primaryDropdownExImData])

    useEffect(() => {
        return () => {
            dispatch({ 
                type: 'RESET_EXIM_DROPDOWN_ACTION', 
                payload: "RESET_EXIM_DROPDOWN_ACTION" 
            });
            dispatch({ 
                type: 'RESET_EXIM_COUNTRY_DROPDOWN_ACTION', 
                payload: "RESET_EXIM_COUNTRY_DROPDOWN_ACTION" 
            });
        };
    }, []);

    
    /* istanbul ignore next */
    useEffect(() => {
        if (isUserDataFetched && secondaryDropdownExImData && secondaryDropdownExImData.type === "SUCCESS_EXIM_COUNTRY_DROPDOWN_ACTION") {
  
            const exImimportingCountries = secondaryDropdownExImData?.importingCountry?.country?.map((item, index) => ({ displayText: item, id: index + 1 }))
            const importingExImYears = secondaryDropdownExImData?.importingCountry?.year?.map((item, index) => ({ displayText: item, id: index + 1 }))

            const exportingExImCountries = secondaryDropdownExImData?.exportingCountry?.country?.map((item, index) => ({ displayText: item, id: index + 1 }))
            const exportingExImYears = secondaryDropdownExImData?.exportingCountry?.year?.map((item, index) => ({ displayText: item, id: index + 1 }))
            setExImImportingCountries(exImimportingCountries)
            setImportingCountryExImSelected(exImimportingCountries)
            setImportingExImYears(importingExImYears)
            setImportingExImYearSelected(importingExImYears)

            setExportingExImCountries(exportingExImCountries)
            setExportingCountryExImSelected(exportingExImCountries)
            setExportingExImYears(exportingExImYears)
            setExportingYearExImSelected(exportingExImYears)

            localStorage.setItem('impCountrySelected_exIm', JSON.stringify(exImimportingCountries))
			localStorage.setItem('impYearSelected_exIm', JSON.stringify(importingExImYears))

            localStorage.setItem('expCountrySelected_exIm', JSON.stringify(exportingExImCountries))
            localStorage.setItem('expYearSelected_exIm', JSON.stringify(exportingExImYears))

            localStorage.setItem('exim_reset_in_progress',0)
            // 
            if(selectedTab == 2){
                loadExImKPIPageDataPart1()
                loadExImKPIPageDataPart2()
            }
            
        }
    }, [secondaryDropdownExImData])

    /* istanbul ignore next */
    useEffect(()=>{
        if(selectedTab == 2){
            // loadExImKPIPageDataPart1()
            // loadExImKPIPageDataPart2()
            localStorage.setItem('exim_current_switch', 0);
            loadsecondaryDropdownExImData()
        }
    },[selectedTab])

    

    /* istanbul ignore next */
    useEffect(() => {
		async function fetchUserInfo() {
			const user = await getUserClaims();
			if (user) {
				setUserInfo(user);
				dispatch(FetchLandingPageAction(user));
				setIsUserDataFetched(true)
			}
		}
        setIsDataLoading(true)
		fetchUserInfo();
	}, []);

    const [blink, setBlink] = useState(false);

    /* istanbul ignore next */
    useEffect(() => {
        const interval = setInterval(() => {
        setBlink(prev => !prev);
        }, 500); // blink speed

        return () => clearInterval(interval);
    }, []);

	// const userData = useSelector((state) => state.getLandingPageReducer);
	const primaryDropdownData = useSelector((state) => state.getImarcDropdownReducer);
	const secondaryDropdownData = useSelector((state) => state.getImarcSecondaryDropdownReducer);
	const imarcData = useSelector((state) => state.getImarcDetailReducer);



    const trendChartOverallValueObject = imarcData?.trendChartOverallValueObject
    const trendChartPricePerUnitValueObject = imarcData?.trendChartPricePerUnitValueObject
    const volumeShareByExportingCountryChartColors = imarcData?.volumeShareByExportingCountry?.donutChartColors
    const volumeShareByExportingCountry = imarcData?.volumeShareByExportingCountry?.countryDetails?.map((item) =>({...item, value: Number(item.value)}))
    const usdShareByExportingCountryChartColors = imarcData?.usdShareByExportingCountry?.donutChartColors
    const usdShareByExportingCountry = imarcData?.usdShareByExportingCountry?.countryDetails?.map((item) =>({...item, value: Number(item.value)}))
    const volumeShareByImportingCountryChartColors = imarcData?.volumeShareByImportingCountry?.donutChartColors
    const volumeShareByImportingCountry = imarcData?.volumeShareByImportingCountry?.countryDetails?.map((item) =>({...item, value: Number(item.value)}))
    const usdShareByImportingCountryChartColors = imarcData?.usdShareByImportingCountry?.donutChartColors
    const usdShareByImportingCountry = imarcData?.usdShareByImportingCountry?.countryDetails?.map((item) =>({...item, value: Number(item.value)}))



    const exImMonthtrendChartOverallValueObject = exImMonthlyData?.trendChartOverallValueObject
    const exImMonthtrendChartPricePerUnitValueObject = exImMonthlyData?.trendChartPricePerUnitValueObject
    // To be updated
    const exImvolumeShareByCountryChartColors = exImCountryData?.volumeShareByCountry?.donutChartColors
    const exImvolumeShareByCountry = exImCountryData?.volumeShareByCountry?.countryDetails?.map((item) =>({...item, value: Number(item.value)}))
    const exImusdShareByCountryChartColors = exImCountryData?.usdShareByCountry?.donutChartColors
    const exImusdShareByCountry = exImCountryData?.usdShareByCountry?.countryDetails?.map((item) =>({...item, value: Number(item.value)}))
   //
    const exImYeartrendChartOverallValueObject = exImCountryData?.trendChartOverallValueObject
    const exImYeartrendChartPricePerUnitValueObject = exImCountryData?.trendChartPricePerUnitValueObject

    /* istanbul ignore next */
    useEffect(() => {
        if (isUserDataFetched && userData && userData.type === "SUCCESS_LANDING_PAGE_ACTION") {


            // dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: false }))
            // // 7 days NPS logic
            // const now = Date.now(); // current timestamp in milliseconds

            // const responseDate = new Date(userData?.mostRecentDate).getTime(); // convert to timestamp in ms

            // const diffInMs = Math.abs(now - responseDate); // difference in milliseconds

            // const daysDiff = diffInMs / (1000 * 60 * 60 * 24); // convert ms to days

            // if (daysDiff >= 7) {
            //     dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: false }))
            // } else {
            //     dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: true }))
            // }

            call7DaysNpsLogic(dispatch, userData)
            const defaultRole = userData?.defaultRole;
            setRoleSelected([{ id: 1, displayText: defaultRole}]);
            setCategoryL0Selected(DEFAULT_IMARC_L0);
            setCategoryL1Selected(DEFAULT_IMARC_L1);

            

            setIsDataLoading(true)
            dispatch(FetchImarcDropdownAction({l0:[],l1:[]}));
        }
		
    }, [userData])

        

        
	
    /* istanbul ignore next */
    useEffect(() => {
        if (isUserDataFetched && primaryDropdownData && primaryDropdownData.type === "SUCCESS_IMARC_DROPDOWN_ACTION") {
            const dropdownData = primaryDropdownData;
            setDropdownValues(dropdownData);

            const materials = getSectorsForSupplierFilters(dropdownData?.dropdownHierarchy); // Function returns level 1 names
            let materialsToInclude = materials?.map(item => (item.displayText ? item.displayText : item));
            setAllMaterials(materials);
            setMaterials(materials);
            setMaterialSelected(materials);
            localStorage.setItem('materialsSelected_imarc', JSON.stringify(materials));

            const grades = getGradeOptions(dropdownData?.dropdownHierarchy, materialsToInclude); 
            let gradesToInclude = grades?.map(item => (item.displayText ? item.displayText : item));
            setGrades(grades);
            setGradeSelected(grades);
            localStorage.setItem('gradeSelected_imarc', JSON.stringify(grades));

            const materialTypes = getTypeOptions(dropdownData?.dropdownHierarchy, materialsToInclude,gradesToInclude);
            let materialTypesToInclude = materialTypes?.map(item => (item.displayText ? item.displayText : item));
            setMaterialTypes(materialTypes)
            setMaterialTypeSelected(materialTypes)
            localStorage.setItem('materialTypesSelected_imarc', JSON.stringify(materialTypes));

            const tradeNames = getTradeNameOptions(dropdownData?.dropdownHierarchy, materialsToInclude,gradesToInclude,materialTypesToInclude)
            let tradeNamesToInclude = tradeNames?.map(item => (item.displayText ? item.displayText : item));
            setTradeNames(tradeNames)
            setTradeNameSelected(tradeNames)
            localStorage.setItem('tradeNamesSelected_imarc', JSON.stringify(tradeNames));
            
            const sizeOptions = getSizeOptions(dropdownData?.dropdownHierarchy, materialsToInclude,gradesToInclude,materialTypesToInclude,tradeNamesToInclude)
            setSizeOptions(sizeOptions)
            setSizeOptionSelected(sizeOptions)
            localStorage.setItem('sizeOptionsSelected_imarc', JSON.stringify(sizeOptions));

            
            let capabilitySearchKey = "IMARC";
            const maxDateForApps = [primaryDropdownData?.dateInfo];
            const maxDateObject = maxDateForApps?.find(item => item?.appName === capabilitySearchKey);
            
            let maxYearValue;
            let maxYearMonth = maxDateObject?.maxYearMonth; // Example: "OCT 2024"
            let yearsArray = [];
            if (maxYearMonth) {
                const [maxMonthText, maxYearText] = maxYearMonth.split(" ");
                maxYearValue = parseInt(maxYearText, 10);
            }

            let minYearMonth = maxDateObject?.minYearMonth;
            let minYearValue;
            if (minYearMonth) {
                        const [minMonthText, minYearText] = minYearMonth.split(" ");
                        minYearValue = parseInt(minYearText, 10);
            }
            
            for (let i = minYearValue; i <= maxYearValue; i++) {
                yearsArray.push(i);
            }

            const allYears = getYears(yearsArray);

            const minYr = allYears[0]?.displayText;
            const minYear = Number(minYr);

            const maxYr = allYears[allYears.length - 1]?.displayText;
            const maxYear = Number(maxYr);

            setEntireMonthList(getMonthsWithYearRangeAdjustedForMaxDate(minYear, maxYear, capabilitySearchKey, maxDateForApps));

            let years = dropdownData?.year?.slice();
            
            const fromDate = getMonthsWithYearWithMaxDate(allYears, maxDateObject);
            setFromDates(fromDate);

            let objectYear = Number(maxDateObject?.maxDate?.split("-")[0]);
            const yearSelected = (objectYear-1) // DEFAULT_FROM_DATE_YEAR // defaultYear;

            const date2 = new Date();
            const date2Year = date2.getFullYear();

            // const fromDateMonth = 'Jan';
            const fromDateMonth = (maxDateObject?.minYearMonth?.split(" ")?.[0]);
            const tempFromDate = fromDate.filter((item) => {
                return item.displayText === (fromDateMonth + ' ' + yearSelected);
            })
            
            let tempToDate = fromDate.filter((item) => {
                let temp = fromDate[fromDate.length - 1]?.displayText;

                let currentLastMonth = Number(yearSelected) < objectYear
                    ? "Dec " + yearSelected
                    : maxYearMonth;

                return item.displayText.toUpperCase() === currentLastMonth.toUpperCase();
            });

            const toDateOptions = getToDateOptionsWithMaxDate(tempFromDate?.[0]?.['displayText'], maxDateObject);
            setToDates(toDateOptions);
            
            const defaultToDateOption = toDateOptions.filter(item=>item.displayText==DEFAULT_TO_DATE)
            if(defaultToDateOption && defaultToDateOption.length>0) {
                tempToDate = defaultToDateOption;
            } else {
                tempToDate = [toDateOptions[toDateOptions.length-1]];
            }

            setFromDateSelected(tempFromDate);
            
            localStorage.setItem('fromDateSelected_imarc', JSON.stringify(tempFromDate))

            setToDateSelected(tempToDate); 
            localStorage.setItem('toDateSelected_imarc', JSON.stringify(tempToDate))
            const index = fromDate.findIndex((item) => item.displayText === tempToDate[0]?.displayText);
            if (index !== -1) {
                const tempFromDates = fromDate.slice(0, index + 1);
                setFromDates(tempFromDates);
            }
            loadSecondaryDropdownData()

        }
    }, [primaryDropdownData])

       /* istanbul ignore next */
       useEffect(() => {
        return () => {
            dispatch({ 
                type: 'RESET_IMARC_DROPDOWN_ACTION', 
                payload: "RESET_IMARC_DROPDOWN_ACTION" 
            });
            dispatch({ 
                type: 'SUCCESS_IMARC_COUNTRY_DROPDOWN_ACTION', 
                payload: "SUCCESS_IMARC_COUNTRY_DROPDOWN_ACTION" 
            });
            dispatch({ 
                type: 'SUCCESS_IMARC_DETAIL_ACTION', 
                payload: "SUCCESS_IMARC_DETAIL_ACTION" 
            });
        };
    }, []);

    
    /* istanbul ignore next */
    useEffect(() => {
        if (isUserDataFetched && secondaryDropdownData && secondaryDropdownData.type === "SUCCESS_IMARC_COUNTRY_DROPDOWN_ACTION") {
            setSecondaryDropdownValues(secondaryDropdownData)
            
            const expCountries = getSectorsForSupplierFilters(secondaryDropdownData?.exportingCountry); // Function returns level 1 names
            let exportingCountriesToInclude = expCountries?.map(item => (item.displayText ? item.displayText : item));

            const impCountries = getImportingCountries(secondaryDropdownData?.exportingCountry,exportingCountriesToInclude);

            setExportingCountries(expCountries)
            setExportingCountrySelected(expCountries)
            setImportingCountries(impCountries)
            setImportingCountrySelected(impCountries)
            localStorage.setItem('expCountrySelected_imarc', JSON.stringify(expCountries));
            localStorage.setItem('impCountrySelected_imarc', JSON.stringify(impCountries));
            loadKPIPageData()
        }
    }, [secondaryDropdownData])

    /* istanbul ignore next */
    useEffect(() => {
        if (isUserDataFetched && imarcData && imarcData.type === "SUCCESS_IMARC_DETAIL_ACTION") {
            
            setIsDataLoading(false);
            // setIsExImDataLoading(false)
            switcherIndex == 0 ? 
                settrendAnalyticsLineBarChartData(imarcData?.trendChartOverallValueObject) : 
                settrendAnalyticsLineBarChartData(imarcData?.trendChartPricePerUnitValueObject)
            setSwitcherIndex(0)
            
        }
    }, [imarcData])

    /* istanbul ignore next */
    useEffect(() => {
        if (isUserDataFetched && exImMonthlyData && exImMonthlyData.type === "SUCCESS_EXIM_MONTHLY_REPORT_ACTION") {
            
            setIsExImDataLoading(false);
            setIsExImMonthPart1DataLoading(false)
            exIMswitcherLineBarChartIndex == 0 ? 
                setexImMonthtrendAnalyticsLineBarChartData(exImMonthlyData?.trendChartOverallValueObject) : 
                setexImMonthtrendAnalyticsLineBarChartData(exImMonthlyData?.trendChartPricePerUnitValueObject)
            setExIMswitcherLineBarChartIndex(0)
            
        }
    }, [exImMonthlyData])
    //

    /* istanbul ignore next */
    useEffect(() => {
        if (isUserDataFetched && exImCountryData && exImCountryData.type === "SUCCESS_EXIM_COUNTRY_REPORT_ACTION") {
            
            setIsExImDataLoading(false);
            setIsExImYearPart2DataLoading(false);
            // setIsExImDataLoading(false)
            
            exIMswitcherByCountryLineBarChartIndex == 0 ? 
                setexImYeartrendAnalyticsLineBarChartData(exImCountryData?.trendChartOverallValueObject) : 
                setexImYeartrendAnalyticsLineBarChartData(exImCountryData?.trendChartPricePerUnitValueObject)
            // setCountryexImSwitcherIndex(0)
            
        }
    }, [exImCountryData])

    //ExIm-------------------------------------------------------------------------------------

    /* istanbul ignore next */
    const loadExImKPIPageDataPart1 = ()=> {

        const l0Selected = JSON.parse(localStorage.getItem("categoryL0Selected_exIm"));  
        const l1Selected = JSON.parse(localStorage.getItem("categoryL1Selected_exIm")); 
        const l2Selected = JSON.parse(localStorage.getItem("categoryL2Selected_exIm")); 
        const productDescription = JSON.parse(localStorage.getItem('descriptionSelected_exIm')); 
        const hsCodes = JSON.parse(localStorage.getItem("hsCodeSelected_exIm"));
        const fromDateSelected_exIm = JSON.parse(localStorage.getItem("fromDateSelected_exIm"));
        const toDateSelected_exIm = JSON.parse(localStorage.getItem("toDateSelected_exIm"));
        const exim_current_switch = JSON.parse(localStorage.getItem("exim_current_switch"));
        if(l0Selected?.length>0 &&
            l1Selected?.length>0 &&
            l2Selected?.length>0 
            // &&
            // hsCodes?.length>0
        ) {
            let requestObject = {};
            
            if(exim_current_switch == 0) {
                if(productDescription?.length>0) {
                    requestObject = {
                        l0: l0Selected?.map((item) => item.displayText ? item.displayText : item),
                        l1: l1Selected?.map((item) => item.displayText ? item.displayText : item),
                        l2: l2Selected?.map((item) => item.displayText ? item.displayText : item),
                        productDescription: productDescription[0]?.displayText,
                        fromDate: fromDateSelected_exIm[0]?.value,
                        toDate: toDateSelected_exIm[0]?.value,
                    };

                } else {
                    message.warning("Please select required filters");
                }

            } else {
                if(hsCodes?.length>0) {
                    requestObject = {
                        l0: l0Selected?.map((item) => item.displayText ? item.displayText : item),
                        l1: l1Selected?.map((item) => item.displayText ? item.displayText : item),
                        l2: l2Selected?.map((item) => item.displayText ? item.displayText : item),
                        hsCode: hsCodes[0]?.displayText,
                        fromDate: fromDateSelected_exIm[0]?.value,
                        toDate: toDateSelected_exIm[0]?.value,
                    };
                } else {
                    message.warning("Please select required filters");
                }

            }
            setIsExImMonthPart1DataLoading(true); 
            dispatch(FetchExImMonthlyReportAction(requestObject)); 
        } else {

            message.warning("Please select required filters");
        }
    }

    /* istanbul ignore next */
    const loadExImKPIPageDataPart2 = ()=> {

        const l0Selected = JSON.parse(localStorage.getItem("categoryL0Selected_exIm"));  
        const l1Selected = JSON.parse(localStorage.getItem("categoryL1Selected_exIm")); 
        const l2Selected = JSON.parse(localStorage.getItem("categoryL2Selected_exIm")); 
        const productDescription = JSON.parse(localStorage.getItem('descriptionSelected_exIm')); 
        const hsCodes = JSON.parse(localStorage.getItem("hsCodeSelected_exIm"));
        const countryExImSwitcherIndex =  Number(localStorage.getItem('exim_current_country_switch'));
        const expCountrySelected =  JSON.parse(localStorage.getItem('expCountrySelected_exIm'));
        const impCountrySelected=  JSON.parse(localStorage.getItem('impCountrySelected_exIm'));
        const expYearSelected_exIm=  JSON.parse(localStorage.getItem('expYearSelected_exIm'));
        const impYearSelected_exIm=  JSON.parse(localStorage.getItem('impYearSelected_exIm'));
        const exim_current_switch = JSON.parse(localStorage.getItem("exim_current_switch"));
        if(l0Selected?.length>0 &&
            l1Selected?.length>0 &&
            l2Selected?.length>0 
            // &&
            // hsCodes?.length>0
        ) {
            let requestObject = {};
            const countryLength = countryExImSwitcherIndex === 0 ? expCountrySelected : impCountrySelected;
            const yearLength = countryExImSwitcherIndex === 0 ? expYearSelected_exIm : impYearSelected_exIm;

            if(exim_current_switch == 0) {
                    if(productDescription?.length>0 && countryLength?.length > 0 && yearLength?.length > 0) {
                        requestObject = {
                            l0: l0Selected?.map((item) => item.displayText ? item.displayText : item),
                            l1: l1Selected?.map((item) => item.displayText ? item.displayText : item),
                            l2: l2Selected?.map((item) => item.displayText ? item.displayText : item),
                            productDescription: productDescription[0]?.displayText,
                            //"country", "year", "countryType",
                            year: countryExImSwitcherIndex == 0 ? expYearSelected_exIm?.map((item) => item.displayText ? item.displayText : item)
                                                                : impYearSelected_exIm?.map((item) => item.displayText ? item.displayText : item),
                            country : countryExImSwitcherIndex == 0 ? expCountrySelected?.map((item) => item.displayText ? item.displayText : item)
                                            : impCountrySelected?.map((item) => item.displayText ? item.displayText : item),
                            countryType: countryExImSwitcherIndex == 0 ? 'Exports' : 'Imports'
                        };
    
                    } else {
                        message.warning("Please select required filters");
                    }

            } else {
                if(hsCodes?.length>0 && countryLength?.length > 0 && yearLength?.length > 0) {
                    requestObject = {
                        l0: l0Selected?.map((item) => item.displayText ? item.displayText : item),
                        l1: l1Selected?.map((item) => item.displayText ? item.displayText : item),
                        l2: l2Selected?.map((item) => item.displayText ? item.displayText : item),
                        hsCode: hsCodes[0]?.displayText,
                        year: countryExImSwitcherIndex == 0 ? expYearSelected_exIm?.map((item) => item.displayText ? item.displayText : item)
                                                            : impYearSelected_exIm?.map((item) => item.displayText ? item.displayText : item),
                        country : countryExImSwitcherIndex == 0 ? expCountrySelected?.map((item) => item.displayText ? item.displayText : item)
                                        : impCountrySelected?.map((item) => item.displayText ? item.displayText : item),
                        countryType: countryExImSwitcherIndex == 0 ? 'Exports' : 'Imports'
                    };
                } else {
                    message.warning("Please select required filters");
                }

            }
            
            if(Object.keys(requestObject).length > 0){
                setIsExImYearPart2DataLoading(true); 
                dispatch(FetchExImCountryReportAction(requestObject)); 
            }
            
        } else {

            message.warning("Please select required filters");
        }
        setExIMswitcherByCountryLineBarChart(0)
    }

    /* istanbul ignore next */
    const loadsecondaryDropdownExImData = ()=> {
        const l0Selected = JSON.parse(localStorage.getItem("categoryL0Selected_exIm"));  
        const l1Selected = JSON.parse(localStorage.getItem("categoryL1Selected_exIm")); 
        const l2Selected = JSON.parse(localStorage.getItem("categoryL2Selected_exIm")); 
        const productDescription = JSON.parse(localStorage.getItem('descriptionSelected_exIm')); 
        const hsCodes = JSON.parse(localStorage.getItem("hsCodeSelected_exIm"));
        const switcherIndex = Number(localStorage.getItem('exim_current_switch'))
        if(l0Selected?.length>0 &&
            l1Selected?.length>0 &&
            l2Selected?.length>0 &&
            hsCodes?.length>0
        ) {
            let requestObject = {};
            
            if(switcherIndex == 0) {
                if(productDescription?.length>0) {
                    requestObject = {
                        l0: l0Selected?.map((item) => item.displayText ? item.displayText : item),
                        l1: l1Selected?.map((item) => item.displayText ? item.displayText : item),
                        l2: l2Selected?.map((item) => item.displayText ? item.displayText : item),
                        productDescription: productDescription[0]?.displayText
                    };

                } else {
                    message.warning("Please select required filters");
                }

            } else {
                if(hsCodes?.length>0) {
                    requestObject = {
                        l0: l0Selected?.map((item) => item.displayText ? item.displayText : item),
                        l1: l1Selected?.map((item) => item.displayText ? item.displayText : item),
                        l2: l2Selected?.map((item) => item.displayText ? item.displayText : item),
                        hsCode: hsCodes[0]?.displayText
                    };
                } else {
                    message.warning("Please select required filters");
                }

            }
            setIsExImDataLoading(true); 
            dispatch(FetchExImSecondaryDropdownAction(requestObject)); 
        } else {

            message.warning("Please select required filters");
        }

    }

    /* istanbul ignore next */
    const resetHSCodeDescriptionToDefault = (val) => {
        const isDefaultExImChanged = Number(localStorage.getItem('isDefaultChanged_exIm'))
        
        const productDescriptionList = JSON.parse(localStorage.getItem('descriptions_exIm')); 
        const hsCodeList = JSON.parse(localStorage.getItem("hsCodes_exIm"));
        
        let hsCodeSelected = [];
        let productDescriptionSelected= [];
        if(val==1) {
            
            if(isDefaultExImChanged==1) {
                hsCodeSelected = [hsCodeList[0]]
            } else {
                hsCodeSelected = getOverlappingOptionsV2(hsCodeList,[primaryDropdownExImData?.defaultHSCode])
            }
            // setHsCodes(hsCodeList)
            setHsCodeSelected(hsCodeSelected)
            localStorage.setItem('hsCodeSelected_exIm', JSON.stringify(hsCodeSelected))
        } else {
            
            if(isDefaultExImChanged==1) {
                productDescriptionSelected = [productDescriptionList[0]]
            } else {
                productDescriptionSelected = getOverlappingOptionsV2(productDescriptionList,[primaryDropdownExImData?.defaultProductDescription])
                
            }
            // setProductDescriptions(productDescriptionList)
            setProductDescriptionSelected(productDescriptionSelected)
            localStorage.setItem('descriptionSelected_exIm', JSON.stringify(productDescriptionSelected))
        }

        setCurrentTooltipText(getHSCodeDescription(hsCodeMapping, hsCodeSelected?.[0]?.displayText, productDescriptionSelected?.[0]?.displayText, val==0?"productDescription":"hsCode"  ))
    }
    
    /* istanbul ignore next */
    const exImSwitchTabs = (val) => {
        setexImSwitcherIndex(val)
        localStorage.setItem('exim_current_switch', val);
        setExImCurrentFilterModeKey(val==0?"productDescription":"hsCode")
        // setCurrentTooltipText(getHSCodeDescription(hsCodeMapping, hsCodeSelected?.[0]?.displayText, productDescriptionSelected?.[0]?.displayText, val==0?"productDescription":"hsCode"  ))
        resetHSCodeDescriptionToDefault(val)
        loadsecondaryDropdownExImData()
        // 
        // loadExImKPIPageDataPart1()
        // loadExImKPIPageDataPart2()
    }
    /* istanbul ignore next */
    const exImSwitchCountryTabs = (val) => {
        setCountryexImSwitcherIndex(val)
        localStorage.setItem('exim_current_country_switch', val);
        loadExImKPIPageDataPart2()
    }

    /* istanbul ignore next */
    const onRoleExImChange = (val) => {
    }
    /* istanbul ignore next */
    const onCategoryLevel0ExImChange = (val) => {
        if((Number(localStorage.getItem('exim_reset_in_progress'))==1)) {
            localStorage.setItem('exim_reset_in_progress',0)

        } else {
            
            setIsDefaultExImChanged(true);
            localStorage.setItem('isDefaultChanged_exIm', 1)
        }
        if (val && val.length > 0) {
                setCategoryL0ExImSelected(val)
                localStorage.setItem('categoryL0Selected_exIm', JSON.stringify(val))
                
                /*** Process and Select Category L0, L1, L2 Dropdown Values ***/
                let categoriesL0ToInclude = val?.map(item => (item.displayText));
                const l1Categories = getCategoriesL1ForSupplierFilters(primaryDropdownExImData?.l0, categoriesL0ToInclude)
                let categoriesL1ToInclude = l1Categories?.map(item => (item.displayText));
                setCategoriesExImLevel1(l1Categories)
                setCategoryL1ExImSelected(l1Categories)
                localStorage.setItem('categoryL1Selected_exIm', JSON.stringify(l1Categories))

                const l2Categories = getCategoriesL2ForExImFilters(primaryDropdownExImData?.l0, categoriesL0ToInclude, categoriesL1ToInclude)
                let categoriesL2ToInclude = l2Categories?.map(item => (item.displayText));

                const productDescriptionStrings = (getFilterModeValues(primaryDropdownExImData?.l0, categoriesL0ToInclude, categoriesL1ToInclude, categoriesL2ToInclude, "productDescription" )).sort((a, b) => a.localeCompare(b))
                const productDescriptions = productDescriptionStrings?.map((item, index) => ({ displayText: item, id: index + 1 }))
                const productDescriptionSelected = [productDescriptions[0]]

                const hsCodesStrings = (getFilterModeValues(primaryDropdownExImData?.l0, categoriesL0ToInclude, categoriesL1ToInclude, categoriesL2ToInclude, "hsCode" )).sort((a, b) => a.localeCompare(b))
                const hsCodes = hsCodesStrings?.map((item, index) => ({ displayText: item, id: index + 1 }))
                const hsCodeSelected = [hsCodes[0]]

                
                localStorage.setItem('hsCodes_exIm', JSON.stringify(hsCodes))
                setHsCodes(hsCodes)
                localStorage.setItem('hsCodeSelected_exIm', JSON.stringify(hsCodeSelected))
                setHsCodeSelected(hsCodeSelected)

                localStorage.setItem('categoryL2Selected_exIm', JSON.stringify(l2Categories))
                setCategoryL2ExImSelected(l2Categories)
                setCategoriesExImLevel2(l2Categories)

                
                localStorage.setItem('descriptionSelected_exIm', JSON.stringify(productDescriptionSelected))
                setProductDescriptionSelected(productDescriptionSelected)
                localStorage.setItem('descriptions_exIm', JSON.stringify(productDescriptions))
                setProductDescriptions(productDescriptions)
                
                setCurrentTooltipText(getHSCodeDescription(hsCodeMapping, hsCodeSelected?.[0]?.displayText, productDescriptionSelected?.[0]?.displayText, exImswitcherIndex==0?"productDescription":"hsCode"  ))
            

                loadsecondaryDropdownExImData()
           
        } else {

            if (val && val.length === 0) {
                setCategoryL0ExImSelected([])
                localStorage.setItem('categoryL0Selected_exIm', JSON.stringify([]))
                setCategoryL1ExImSelected([])
                localStorage.setItem('categoryL1Selected_exIm', JSON.stringify([]))
                setCategoryL2ExImSelected([])
                localStorage.setItem('categoryL2Selected_exIm', JSON.stringify([]))
                message.warning("At least one category L0 is required")
            }
        }
    }
    /* istanbul ignore next */
    const onCategoryLevel1ExImChange = (val) => {
        
        setIsDefaultExImChanged(true);
        localStorage.setItem('isDefaultChanged_exIm', 1)
        if (val && val.length > 0) {
            if (categoryL0ExImSelected.length > 0) {
                setCategoryL1ExImSelected(val)
                localStorage.setItem('categoryL1Selected_exIm', JSON.stringify(val))
                
                let categoriesL0ToInclude = categoryL0ExImSelected?.map(item => (item.displayText))
                let categoriesL1ToInclude = val?.map(item => (item.displayText))

                const l2Categories = getCategoriesL2ForExImFilters(primaryDropdownExImData?.l0, categoriesL0ToInclude, categoriesL1ToInclude)
                let categoriesL2ToInclude = l2Categories?.map(item => (item.displayText));
                setCategoriesExImLevel2(l2Categories)
                setCategoryL2ExImSelected(l2Categories)
                localStorage.setItem('categoryL2Selected_exIm', JSON.stringify(l2Categories))

                const hsCodesStrings = (getFilterModeValues(primaryDropdownExImData?.l0, categoriesL0ToInclude, categoriesL1ToInclude, categoriesL2ToInclude, "hsCode" )).sort((a, b) => a.localeCompare(b))
                const hsCodes = hsCodesStrings?.map((item, index) => ({ displayText: item, id: index + 1 }))
                const hsCodeSelected = [hsCodes[0]]
                setHsCodes(hsCodes)
                setHsCodeSelected(hsCodeSelected)
                localStorage.setItem('hsCodes_exIm', JSON.stringify(hsCodes))
                localStorage.setItem('hsCodeSelected_exIm', JSON.stringify(hsCodeSelected))

                const productDescriptionStrings = (getFilterModeValues(primaryDropdownExImData?.l0, categoriesL0ToInclude, categoriesL1ToInclude, categoriesL2ToInclude, "productDescription" )).sort((a, b) => a.localeCompare(b))
                const productDescriptions = productDescriptionStrings?.map((item, index) => ({ displayText: item, id: index + 1 }))
                const productDescriptionSelected = [productDescriptions[0]]
                setProductDescriptionSelected(productDescriptionSelected)
                setProductDescriptions(productDescriptions)
                localStorage.setItem('descriptions_exIm', JSON.stringify(productDescriptions))
                localStorage.setItem('descriptionSelected_exIm', JSON.stringify(productDescriptionSelected))
                
            
                setCurrentTooltipText(getHSCodeDescription(hsCodeMapping, hsCodeSelected?.[0]?.displayText, productDescriptionSelected?.[0]?.displayText, exImswitcherIndex==0?"productDescription":"hsCode"  ))
            
                loadsecondaryDropdownExImData()
            } else {
                    message.warning("Please select at least one category 0")
            }
            
        } else {

            if (val && val.length === 0) {
                setCategoryL1ExImSelected([])
                localStorage.setItem('categoryL1Selected_exIm', JSON.stringify([]))
                setCategoryL2ExImSelected([])
                localStorage.setItem('categoryL2Selected_exIm', JSON.stringify([]))
            }
        }
    }
    /* istanbul ignore next */
    const onCategoryLevel2ExImChange = (val) => {
        
        setIsDefaultExImChanged(true);
        localStorage.setItem('isDefaultChanged_exIm', 1)
        if (val && val.length > 0) {
            if (categoryL0ExImSelected.length > 0) {
                if (categoryL1ExImSelected.length > 0) {
                    setCategoryL2ExImSelected(val)
                    localStorage.setItem('categoryL2Selected_exIm', JSON.stringify(val))
                    let categoriesL0ToInclude = categoryL0ExImSelected?.map(item => (item.displayText))
                    let categoriesL1ToInclude = categoryL1ExImSelected?.map(item => (item.displayText))
                    let categoriesL2ToInclude = val?.map(item => (item.displayText));

                    const hsCodesStrings = (getFilterModeValues(primaryDropdownExImData?.l0, categoriesL0ToInclude, categoriesL1ToInclude, categoriesL2ToInclude, "hsCode" )).sort((a, b) => a.localeCompare(b))
                    const hsCodes = hsCodesStrings?.map((item, index) => ({ displayText: item, id: index + 1 }))
                    const hsCodeSelected = [hsCodes[0]]
                    setHsCodeSelected(hsCodeSelected)                    
                    localStorage.setItem('hsCodeSelected_exIm', JSON.stringify(hsCodeSelected))
                    setHsCodes(hsCodes)
                    localStorage.setItem('hsCodes_exIm', JSON.stringify(hsCodes))
                    

                    const productDescriptionStrings = (getFilterModeValues(primaryDropdownExImData?.l0, categoriesL0ToInclude, categoriesL1ToInclude, categoriesL2ToInclude, "productDescription" )).sort((a, b) => a.localeCompare(b))
                    const productDescriptions = productDescriptionStrings?.map((item, index) => ({ displayText: item, id: index + 1 }))
                    const productDescriptionSelected = [productDescriptions[0]]
                    
                    setProductDescriptions(productDescriptions)
                    localStorage.setItem('descriptions_exIm', JSON.stringify(productDescriptions))

                    setProductDescriptionSelected(productDescriptionSelected)
                    localStorage.setItem('descriptionSelected_exIm', JSON.stringify(productDescriptionSelected))
                    setCurrentTooltipText(getHSCodeDescription(hsCodeMapping, hsCodeSelected?.[0]?.displayText, productDescriptionSelected?.[0]?.displayText, exImswitcherIndex==0?"productDescription":"hsCode"  ))
            
                    
                    loadsecondaryDropdownExImData()
                } else {
                    message.warning("Please select at least one category 1")
                }
            } else {
                message.warning("Please select at least one category 0")
            }
        } else {

            if (val && val.length === 0) {
                setCategoryL2ExImSelected([])
                localStorage.setItem('categoryL2Selected_exIm', JSON.stringify([]))
                
                message.warning("At least one category L2 is required")
            }
        }
    }

    /* istanbul ignore next */
    const onHSCodeChange = (val)=> {
        
        // setIsDefaultExImChanged(true);
        // localStorage.setItem('isDefaultChanged_exIm', 1)
        if (val && val.length > 0) {
            setHsCodeSelected(val)
            setCurrentTooltipText(getHSCodeDescription(hsCodeMapping, val?.[0]?.displayText, productDescriptionSelected?.[0]?.displayText, exImswitcherIndex==0?"productDescription":"hsCode"  ))
            localStorage.setItem('hsCodeSelected_exIm', JSON.stringify(val))
            loadsecondaryDropdownExImData()
        } else {
            if (val && val.length === 0) {
                message.warning("HS Code selection is required")
            }
        }
    }
    /* istanbul ignore next */
    const onDescriptionChange = (val)=> {
        
        // setIsDefaultExImChanged(true);
        // localStorage.setItem('isDefaultChanged_exIm', 1)
        if (val && val.length > 0) {
            setProductDescriptionSelected(val)
            setCurrentTooltipText(getHSCodeDescription(hsCodeMapping, hsCodeSelected?.[0]?.displayText, val?.[0]?.displayText, exImswitcherIndex==0?"productDescription":"hsCode"  ))
            localStorage.setItem('descriptionSelected_exIm', JSON.stringify(val))
            loadsecondaryDropdownExImData()
        } else {
            if (val && val.length === 0) {
                message.warning("Production Description selection is required")
            }
        }
    }

    
    /* istanbul ignore next */
    const onFromDateExImChange = (val) => {
        if (val && val.length > 0) {
            setFromDateExImSelected(val)
            localStorage.setItem('fromDateSelected_exIm', JSON.stringify(val))
            const toDateOptions = getToDateOptions(val[0]['displayText']);

            const dateObject = {
                appName: "ExIm",
                maxDate: primaryDropdownExImData?.dateDetail?.maxDate,
                maxYearMonth: primaryDropdownExImData?.dateDetail?.maxYearMonth,
            }
            let capabilitySearchKey = "ExIm";
            const maxDateForApps = [dateObject];
            
            const maxDateObject = maxDateForApps?.find(item => item?.appName === capabilitySearchKey);
            const toDateOptions1 = getToDateOptionsWithMaxDate(val[0]['displayText'], maxDateObject);
            setExImToDates(toDateOptions1);

            let tempY = val[0]['displayText']?.split(" ")?.[1]
            const date2 = new Date(toDateExImSelected?.[0]?.['displayText']);
            const toDateMonth = months[date2?.getMonth()];;
            const date2Year = date2?.getFullYear();
            
            const date1 = new Date(val[0]['displayText']);
            
            const customTempToDate = toDateOptions1?.filter((item) => { // CHANGED
                return item.displayText === (`${toDateMonth} ` + date2Year);
            })
            const tempToDate = toDateOptions1?.filter((item) => { // CHANGED
                return item.displayText === ('Dec ' + tempY);
            })

           
            ChangeExImToDateOptions(val[0])

            if (!isNaN(date1.getTime()) && !isNaN(date2?.getTime())) {
                if (date1 <= date2) {
                    setToDateExImSelected(customTempToDate); 
                    localStorage.setItem('toDateSelected_exIm', JSON.stringify(customTempToDate))
                    loadExImKPIPageDataPart1();
                } else {
                    setToDateExImSelected(tempToDate);
                    localStorage.setItem('toDateSelected_exIm', JSON.stringify(tempToDate))
                    loadExImKPIPageDataPart1();
                }
            } else {
                loadExImKPIPageDataPart1();
            }
        } else {
            message.warning("From Date is not selected")

        }
    }
    /* istanbul ignore next */
    const onToDateExImChange = (val) => {
        if (val && val.length > 0) {
            setToDateExImSelected(val)
            localStorage.setItem('toDateSelected_exIm', JSON.stringify(val))
            changeExImFromDateOptions(val[0]);
            loadExImKPIPageDataPart1();
        } else {
            message.warning("To Date is not selected")

        }
    }

    /* istanbul ignore next */
    const changeExImFromDateOptions = (toDateMonthSelected) => {
        const toDateExImSelected = toDateMonthSelected.displayText;
        const maxDate = new Date(toDateExImSelected);
        const filteredMonths = exImentireMonthList.filter((month) => {
            const monthDate = new Date(month.value);
            return monthDate <= maxDate;
        });
        filteredMonths.push(toDateMonthSelected);
        filteredMonths.sort((a, b) => new Date(a.value) - new Date(b.value));
        setExImFromDates(filteredMonths)
    }

    /* istanbul ignore next */
    const ChangeExImToDateOptions = (fromDateMonthSelected) => {
        const toDateSelected1 = fromDateMonthSelected.displayText;
        const fromDate = new Date(toDateSelected1);
        const filteredMonths = exImentireMonthList.filter((month) => {
            const monthDate = new Date(month.value);
            return monthDate >= fromDate;
        });
        setExImToDates(filteredMonths);
    };

    
    /* istanbul ignore next */
    const onExportCountryExImChange = (val)=> {
        if (val && val.length > 0) {
            setExportingCountryExImSelected(val)
            localStorage.setItem('expCountrySelected_exIm', JSON.stringify(val))
            loadExImKPIPageDataPart2()
        } else {
            if (val && val.length === 0) {
                setExportingCountryExImSelected([])
                localStorage.setItem('expCountrySelected_exIm', JSON.stringify([]))
                message.warning("Please select Required Filters")
            }
        }
    }
    /* istanbul ignore next */
    const onExportYearExImChange = (val)=> {
        if (val && val.length > 0) {
            setExportingYearExImSelected(val)
            localStorage.setItem('expYearSelected_exIm', JSON.stringify(val))
            loadExImKPIPageDataPart2()
        } else {
            if (val && val.length === 0) {
                setExportingYearExImSelected([])
                localStorage.setItem('expYearSelected_exIm', JSON.stringify([]))
                message.warning("Please select Required Filters")
            }
        }
    }
    /* istanbul ignore next */
    const onImportCountryExImChange = (val)=> {
        
        if (val && val.length > 0) {
            setImportingCountryExImSelected(val)
            localStorage.setItem('impCountrySelected_exIm', JSON.stringify(val))
            loadExImKPIPageDataPart2()
        } else {
            if (val && val.length === 0) {
                setImportingCountryExImSelected([])
                localStorage.setItem('impCountrySelected_exIm', JSON.stringify([]))
                message.warning("Please select Required Filters")
            }
        }
    }
    /* istanbul ignore next */
    const onImportYearExImChange = (val)=> {
        
        if (val && val.length > 0) {
            setImportingExImYearSelected(val)
            localStorage.setItem('impYearSelected_exIm', JSON.stringify(val))
            loadExImKPIPageDataPart2()
        } else {
            if (val && val.length === 0) { 
                setImportingExImYearSelected([])
                localStorage.setItem('impYearSelected_exIm', JSON.stringify([]))
                message.warning("Please select Required Filters")
            }
        }
    }

    /* istanbul ignore next */
    useEffect(()=>{


        exIMswitcherLineBarChartIndex == 0 ? 
        setexImMonthtrendAnalyticsLineBarChartData(exImMonthtrendChartOverallValueObject) : 
        setexImMonthtrendAnalyticsLineBarChartData(exImMonthtrendChartPricePerUnitValueObject)

    }, [exIMswitcherLineBarChartIndex]) 

    /* istanbul ignore next */
    useEffect(()=>{

        
        exIMswitcherByCountryLineBarChartIndex == 0 ? 
        setexImYeartrendAnalyticsLineBarChartData(exImYeartrendChartOverallValueObject) : 
        setexImYeartrendAnalyticsLineBarChartData(exImYeartrendChartPricePerUnitValueObject)

    }, [exIMswitcherByCountryLineBarChartIndex])

    // useEffect(()=>{

    //     countryexImSwitcherIndex == 0 ? 
    //     setexImYeartrendAnalyticsLineBarChartData(exImYeartrendChartOverallValueObject) : 
    //     setexImYeartrendAnalyticsLineBarChartData(exImYeartrendChartPricePerUnitValueObject)
        
    //     // if(selectedTab == 2){
    //     //     loadExImKPIPageDataPart2()
    //     // }
        

    // }, [countryexImSwitcherIndex])


    /* istanbul ignore next */
    const exIMconditionalLegend = exIMswitcherLineBarChartIndex == 0 
        ? { name: "Overall Value (USD, MN)", color: "#B05788" }
        : { name: `Price per ${exImMonthlyData?.unit} (USD/${exImMonthlyData?.unit})`, color: "#B05788" };
    /* istanbul ignore next */
    const exIMlineChartLegends = [
        {
            "name": "Volume",
            "color": "#33ABDA"
        },
        exIMconditionalLegend
    ]
    /* istanbul ignore next */
    const exIMByCountryconditionalLegend = exIMswitcherByCountryLineBarChartIndex == 0 
        ? { name: "Overall Value (USD, MN)", color: "#B05788" }
        : { name: `Price per ${exImCountryData?.unit} (USD/${exImCountryData?.unit})`, color: "#B05788" };
    /* istanbul ignore next */
    const exIMByCountrylineChartLegends = [
        {
            "name": "Volume",
            "color": "#33ABDA"
        },
        exIMByCountryconditionalLegend
    ]

        const { showToast } = useToast();
        /* istanbul ignore next */
        const checkPDFDownloaded = () => {}
     

    //-------------------------------------------------------------------------------------------


	
	

    /* istanbul ignore next */
    useEffect(()=>{

        switcherIndex == 0 ? 
        settrendAnalyticsLineBarChartData(trendChartOverallValueObject) : 
        settrendAnalyticsLineBarChartData(trendChartPricePerUnitValueObject)


    }, [switcherIndex])


    /* istanbul ignore next */
    const loadKPIPageData = ()=> {
        
        const materials = JSON.parse(localStorage.getItem("materialsSelected_imarc"));  
        const grades = JSON.parse(localStorage.getItem("gradeSelected_imarc")); 
        const materialTypes = JSON.parse(localStorage.getItem("materialTypesSelected_imarc")); 
        const tradeNames = JSON.parse(localStorage.getItem("tradeNamesSelected_imarc")); 
        const sizeOptions = JSON.parse(localStorage.getItem("sizeOptionsSelected_imarc")); 
        const expCountries = JSON.parse(localStorage.getItem("expCountrySelected_imarc") || []);
        const impCountries = JSON.parse(localStorage.getItem("impCountrySelected_imarc") || []);
        const fromDateData = JSON.parse(localStorage.getItem("fromDateSelected_imarc")); 
        const toDateData = JSON.parse(localStorage.getItem("toDateSelected_imarc"));
        
        if(materials.length>0 &&
            grades.length>0 &&
            materialTypes.length>0 &&
            tradeNames.length>0 &&
            fromDateData.length>0 &&
            toDateData.length>0 &&
            sizeOptions.length>0 &&
            expCountries.length>0 &&
            impCountries.length>0
        ) {
            const requestObject = {
                fromDate: fromDateData?.[0]?.value || '',
                toDate: toDateData?.[0]?.value || '',
                material: materials?.map((item) => item.displayText),
                grade: grades?.map((item) => item.displayText),
                type: materialTypes?.map((item) => item.displayText),
                tradeName: tradeNames?.map((item) => item.displayText),
                size: sizeOptions?.map((item) => item.displayText),
                exportingCountry: expCountries?.map((item) => item.displayText),
                importingCountry: impCountries?.map((item) => item.displayText),
                mailId: userData?.emailId
            };
            
            setIsDataLoading(true);
            dispatch(FetchImarcDetailAction(requestObject));

        } else {
            message.warning("Please select required filters");
        }
    }

    /* istanbul ignore next */
    const loadSecondaryDropdownData = ()=> {
        const materials = JSON.parse(localStorage.getItem("materialsSelected_imarc"));  
        const grades = JSON.parse(localStorage.getItem("gradeSelected_imarc")); 
        const materialTypes = JSON.parse(localStorage.getItem("materialTypesSelected_imarc")); 
        const tradeNames = JSON.parse(localStorage.getItem("tradeNamesSelected_imarc")); 
        const sizeOptions = JSON.parse(localStorage.getItem("sizeOptionsSelected_imarc"));
        if(materials.length>0 &&
            grades.length>0 &&
            materialTypes.length>0 &&
            tradeNames.length>0 &&
            sizeOptions.length>0
        ) { 
            const requestObject = {
                material: materials?.map((item) => item.displayText ? item.displayText : item),
                grade: grades?.map((item) => item.displayText ? item.displayText : item),
                type: materialTypes?.map((item) => item.displayText ? item.displayText : item),
                tradeName: tradeNames?.map((item) => item.displayText ? item.displayText : item),
                size: sizeOptions?.map((item) => item.displayText ? item.displayText : item),
            };
            setIsDataLoading(true); 
            dispatch(FetchImarcSecondaryDropdownAction(requestObject));
        } else {

            message.warning("Please select required filters");
        }

    }

    /* istanbul ignore next */
    const onFromDateChange = (val) => {
        if (val && val.length > 0) {
            setFromDateSelected(val)
            localStorage.setItem('fromDateSelected_imarc', JSON.stringify(val))
            const toDateOptions = getToDateOptions(val[0]['displayText']);

            
            const maxDateForApps = [primaryDropdownData?.dateInfo];
            let capabilitySearchKey = "IMARC";
            const maxDateObject = maxDateForApps?.find(item => item?.appName === capabilitySearchKey);
            const toDateOptions1 = getToDateOptionsWithMaxDate(val[0]['displayText'], maxDateObject);
            setToDates(toDateOptions1);

            let tempY = val[0]['displayText']?.split(" ")?.[1]
            
            const date2 = new Date(toDateSelected?.[0]?.['displayText']);
            const toDateMonth = months[date2?.getMonth()];
            const date2Year = date2?.getFullYear();
            
            const date1 = new Date(val[0]['displayText']);

            

            const customTempToDate = toDateOptions1?.filter((item) => { // CHANGED
                return item.displayText === (`${toDateMonth} ` + date2Year);
            })
            const tempToDate = toDateOptions1?.filter((item) => { // CHANGED
                return item.displayText === ('Dec ' + tempY);
            })
            changeToDateOptions(val[0])

            if (!isNaN(date1.getTime()) && !isNaN(date2?.getTime())) {
                if (date1 <= date2) {
                    setToDateSelected(customTempToDate); 
                    localStorage.setItem('toDateSelected_imarc', JSON.stringify(customTempToDate))
                    loadKPIPageData();
                } else {
                    setToDateSelected(tempToDate);
                    localStorage.setItem('toDateSelected_imarc', JSON.stringify(tempToDate))
                    loadKPIPageData();
                }
            } else {
                loadKPIPageData();
            }
        } else {
            message.warning("From Date is not selected")

        }
    }
    /* istanbul ignore next */
    const onToDateChange = (val) => {
        if (val && val.length > 0) {
            setToDateSelected(val)
            localStorage.setItem('toDateSelected_imarc', JSON.stringify(val))
            changeFromDateOptions(val[0]);
            loadKPIPageData();
        } else {
            message.warning("To Date is not selected")

        }
    }

    /* istanbul ignore next */
    const changeFromDateOptions = (toDateMonthSelected) => {
        // const toDateSelected = toDateMonthSelected.displayText;
        // const maxDate = new Date(toDateSelected);
        // const filteredMonths = entireMonthList.filter((month) => {
        //     const monthDate = new Date(month.value);
        //     return monthDate <= maxDate;
        // });
        // filteredMonths.push(toDateMonthSelected);
        // filteredMonths.sort((a, b) => new Date(a.value) - new Date(b.value));

        const filteredMonths = changeFromDateOptionsUtil(toDateMonthSelected,entireMonthList)
        setFromDates(filteredMonths)
    }

    /* istanbul ignore next */
    const changeToDateOptions = (fromDateMonthSelected) => {
        // const toDateSelected1 = fromDateMonthSelected.displayText;
        // const fromDate = new Date(toDateSelected1);
        // const filteredMonths = entireMonthList.filter((month) => {
        //     const monthDate = new Date(month.value);
        //     return monthDate >= fromDate;
        // });

        const filteredMonths = changeToDateOptionsUtil(fromDateMonthSelected,entireMonthList)
        setToDates(filteredMonths);
    };

    /* istanbul ignore next */
    const onMaterialChange = (val) => {
        if (val && val.length > 0) {
            const materials = val;
            let materialsToInclude = materials?.map(item => (item.displayText ? item.displayText : item));
            setMaterialSelected(materials);
            localStorage.setItem('materialsSelected_imarc', JSON.stringify(materials));

            const grades = getGradeOptions(dropdownValues?.dropdownHierarchy, materialsToInclude); 
            let gradesToInclude = grades?.map(item => (item.displayText ? item.displayText : item));
            
            const materialTypes = getTypeOptions(dropdownValues?.dropdownHierarchy, materialsToInclude,gradesToInclude);
            let materialTypesToInclude = materialTypes?.map(item => (item.displayText ? item.displayText : item));
            
            const tradeNames = getTradeNameOptions(dropdownValues?.dropdownHierarchy, materialsToInclude,gradesToInclude,materialTypesToInclude)
            let tradeNamesToInclude = tradeNames?.map(item => (item.displayText ? item.displayText : item));
            
            const sizeOptions = getSizeOptions(dropdownValues?.dropdownHierarchy, materialsToInclude,gradesToInclude,materialTypesToInclude,tradeNamesToInclude)
            setSizeOptions(sizeOptions)

            
            setMaterialTypes(materialTypes)
            setMaterialTypeSelected(materialTypes)
            localStorage.setItem('materialTypesSelected_imarc', JSON.stringify(materialTypes));

            setGrades(grades);
            setGradeSelected(grades);
            localStorage.setItem('gradeSelected_imarc', JSON.stringify(grades));


            setSizeOptionSelected(sizeOptions)
            localStorage.setItem('sizeOptionsSelected_imarc', JSON.stringify(sizeOptions));

            localStorage.setItem('tradeNamesSelected_imarc', JSON.stringify(tradeNames));
            setTradeNames(tradeNames)
            setTradeNameSelected(tradeNames)
            
            loadSecondaryDropdownData();
        } else {
            
            if (val && val.length === 0) {
                setMaterialSelected([])
                localStorage.setItem("materialsSelected_imarc", JSON.stringify([]))
                setGradeSelected([])
                localStorage.setItem("gradeSelected_imarc", JSON.stringify([]))
                setMaterialTypeSelected([])
                localStorage.setItem("materialTypesSelected_imarc", JSON.stringify([]))
                setTradeNameSelected([])
                localStorage.setItem("tradeNamesSelected_imarc", JSON.stringify([]))
                setSizeOptionSelected([])
                localStorage.setItem("sizeOptionsSelected_imarc", JSON.stringify([]))
                message.warning("At least one Material selection is required")
            }

        }

    }
    /* istanbul ignore next */
    const onGradeChange = (val) => {
        if (val && val.length > 0) {
            
            const materialsToInclude = materialSelected?.map(item => (item.displayText ? item.displayText : item));
            const grades = val
            let gradesToInclude = grades?.map(item => (item.displayText ? item.displayText : item));
            setGradeSelected(grades);
            localStorage.setItem('gradeSelected_imarc', JSON.stringify(grades));

            const materialTypes = getTypeOptions(dropdownValues?.dropdownHierarchy, materialsToInclude,gradesToInclude);
            let materialTypesToInclude = materialTypes?.map(item => (item.displayText ? item.displayText : item));
            setMaterialTypes(materialTypes)
            setMaterialTypeSelected(materialTypes)
            localStorage.setItem('materialTypesSelected_imarc', JSON.stringify(materialTypes));

            const tradeNames = getTradeNameOptions(dropdownValues?.dropdownHierarchy, materialsToInclude,gradesToInclude,materialTypesToInclude)
            let tradeNamesToInclude = tradeNames?.map(item => (item.displayText ? item.displayText : item));
            setTradeNames(tradeNames)
            setTradeNameSelected(tradeNames)
            localStorage.setItem('tradeNamesSelected_imarc', JSON.stringify(tradeNames));
            
            const sizeOptions = getSizeOptions(dropdownValues?.dropdownHierarchy, materialsToInclude,gradesToInclude,materialTypesToInclude,tradeNamesToInclude)
            setSizeOptions(sizeOptions)
            setSizeOptionSelected(sizeOptions)
            localStorage.setItem('sizeOptionsSelected_imarc', JSON.stringify(sizeOptions));
            loadSecondaryDropdownData();
        } else {
            
            if (val && val.length === 0) {
                setGradeSelected([])
                localStorage.setItem("gradeSelected_imarc", JSON.stringify([]))
                setMaterialTypeSelected([])
                localStorage.setItem("materialTypesSelected_imarc", JSON.stringify([]))
                setTradeNameSelected([])
                localStorage.setItem("tradeNamesSelected_imarc", JSON.stringify([]))
                setSizeOptionSelected([])
                localStorage.setItem("sizeOptionsSelected_imarc", JSON.stringify([]))
                message.warning("At least one Grade selection is required")
            }

        }
    }
    /* istanbul ignore next */
    const onMaterialTypeChange = (val) => {
        
        if (val && val.length > 0) {
            
            const materialsToInclude = materialSelected?.map(item => (item.displayText ? item.displayText : item));
            const gradesToInclude = gradeSelected?.map(item => (item.displayText ? item.displayText : item));

            const materialTypes = val;
            let materialTypesToInclude = materialTypes?.map(item => (item.displayText ? item.displayText : item));
            setMaterialTypeSelected(materialTypes)
            localStorage.setItem('materialTypesSelected_imarc', JSON.stringify(materialTypes));

            const tradeNames = getTradeNameOptions(dropdownValues?.dropdownHierarchy, materialsToInclude,gradesToInclude,materialTypesToInclude)
            let tradeNamesToInclude = tradeNames?.map(item => (item.displayText ? item.displayText : item));
            setTradeNames(tradeNames)
            setTradeNameSelected(tradeNames)
            localStorage.setItem('tradeNamesSelected_imarc', JSON.stringify(tradeNames));
            
            const sizeOptions = getSizeOptions(dropdownValues?.dropdownHierarchy, materialsToInclude,gradesToInclude,materialTypesToInclude,tradeNamesToInclude)
            setSizeOptions(sizeOptions)
            setSizeOptionSelected(sizeOptions)
            localStorage.setItem('sizeOptionsSelected_imarc', JSON.stringify(sizeOptions));
            loadSecondaryDropdownData();
        } else {
            
            if (val && val.length === 0) {
                setMaterialTypeSelected([])
                localStorage.setItem("materialTypesSelected_imarc", JSON.stringify([]))
                setTradeNameSelected([])
                localStorage.setItem("tradeNamesSelected_imarc", JSON.stringify([]))
                setSizeOptionSelected([])
                localStorage.setItem("sizeOptionsSelected_imarc", JSON.stringify([]))
                message.warning("At least one Material Type selection is required")
            }

        }

    }
    /* istanbul ignore next */
    const onTradeNameChange = (val) => {
        if (val && val.length > 0) {

            const materialsToInclude = materialSelected?.map(item => (item.displayText ? item.displayText : item));
            const gradesToInclude = gradeSelected?.map(item => (item.displayText ? item.displayText : item));
            const materialTypesToInclude = materialTypeSelected?.map(item => (item.displayText ? item.displayText : item));

            const tradeNames = val;
            let tradeNamesToInclude = tradeNames?.map(item => (item.displayText ? item.displayText : item));
            setTradeNameSelected(tradeNames)
            localStorage.setItem('tradeNamesSelected_imarc', JSON.stringify(tradeNames));
            
            const sizeOptions = getSizeOptions(dropdownValues?.dropdownHierarchy, materialsToInclude,gradesToInclude,materialTypesToInclude,tradeNamesToInclude)
            setSizeOptions(sizeOptions)
            setSizeOptionSelected(sizeOptions)
            localStorage.setItem('sizeOptionsSelected_imarc', JSON.stringify(sizeOptions));
            loadSecondaryDropdownData();
        } else {
            
            if (val && val.length === 0) {
                setTradeNameSelected([])
                localStorage.setItem("tradeNamesSelected_imarc", JSON.stringify([]))
                setSizeOptionSelected([])
                localStorage.setItem("sizeOptionsSelected_imarc", JSON.stringify([]))
                message.warning("At least one Trade Name selection is required")
            }

        }


    }
    /* istanbul ignore next */
    const onSizeOptionChange = (val) => {
        if (val && val.length > 0) {
            const sizeOptions = val;
            setSizeOptionSelected(sizeOptions)
            localStorage.setItem('sizeOptionsSelected_imarc', JSON.stringify(sizeOptions));
            loadSecondaryDropdownData();
        } else {
            
            if (val && val.length === 0) {
                setSizeOptionSelected([])
                localStorage.setItem("sizeOptionsSelected_imarc", JSON.stringify([]))
                message.warning("At least one Size selection is required")
            }

        }
    }
    /* istanbul ignore next */
    const onExportCountryChange = (val) => {
        if (val && val.length > 0) {
            setExportingCountrySelected(val)
            localStorage.setItem('expCountrySelected_imarc', JSON.stringify(val))

            let exportingCountriesToInclude = val?.map(item => (item.displayText ? item.displayText : item));
            const impCountries = getImportingCountries(secondaryDropdownValues?.exportingCountry,exportingCountriesToInclude);
            setImportingCountries(impCountries)
            setImportingCountrySelected(impCountries)
            localStorage.setItem('impCountrySelected_imarc', JSON.stringify(impCountries));

            loadKPIPageData();
        } else {
            if (val && val.length === 0) {
                setExportingCountrySelected([])
                localStorage.setItem('expCountrySelected_imarc', JSON.stringify([]))
                setImportingCountries([])
                setImportingCountrySelected([])
                localStorage.setItem('impCountrySelected_imarc', JSON.stringify([]));
                message.warning("At least one exporting country selection is required.")
            }
        }
    }
    /* istanbul ignore next */
    const onImportCountryChange = (val) => {
        if (val && val.length > 0) {
            setImportingCountrySelected(val)
            localStorage.setItem('impCountrySelected_imarc', JSON.stringify(val))
            loadKPIPageData();
        } else {
            if (val && val.length === 0) {
                setImportingCountrySelected([])
                localStorage.setItem('impCountrySelected_imarc', JSON.stringify([]))
                message.warning("At least one importing country selection is required.")
            }
        }
    }

    // ExIm -----------------------------------------------------------------------------
    /* istanbul ignore next */
    const resetMonths = () => {
        const dateObject = {
            appName: "ExIm",
            maxDate: primaryDropdownExImData?.dateDetail?.maxDate,
            maxYearMonth: primaryDropdownExImData?.dateDetail?.maxYearMonth,
        }

        const maxDateForApps = [dateObject];
        let capabilitySearchKey = "ExIm";
        const maxDateObject = maxDateForApps?.find(item => item?.appName === capabilitySearchKey);

        let maxYearMonth = maxDateObject?.maxYearMonth; // Example: "OCT 2024"
        let maxYearValue;
    
        if (maxYearMonth) {
            const [maxMonthText, maxYearText] = maxYearMonth.split(" ");
            maxYearValue = parseInt(maxYearText, 10);
        }
        let yearsArray = [];
        for (let i = MIN_EXIM_YEAR; i <= maxYearValue; i++) {
            yearsArray.push(i);
        }

        const allYears = getYears(yearsArray);
        const maxYr = allYears[allYears.length - 1]?.displayText;
        const minYr = allYears[0]?.displayText;

        const minYear = Number(minYr);
        const maxYear = Number(maxYr);

        setExImEntireMonthList(getMonthsWithYearRangeAdjustedForMaxDate(minYear, maxYear, capabilitySearchKey, maxDateForApps));

        
        const fromDate = getMonthsWithYearWithMaxDate(allYears, maxDateObject);
        setExImFromDates(fromDate);

        let objectYear = Number(maxDateObject?.maxDate?.split("-")[0]);

        const date2 = new Date();
        const yearSelected = objectYear-1; // DEFAULT_FROM_DATE_YEAR // defaultYear;
        const date2Year = date2.getFullYear();

        // const fromDateMonth = 'Jan';
        const fromDateMonth = (maxDateObject?.maxYearMonth?.split(" ")?.[0]); // Extracting year from maxDate
        
        let tempToDate = fromDate.filter((item) => {
            let temp = fromDate[fromDate.length - 1]?.displayText;

            let currentLastMonth = Number(yearSelected) < objectYear
                ? "Dec " + yearSelected
                : maxYearMonth;

            return item.displayText.toUpperCase() === currentLastMonth.toUpperCase();
        });

        const tempFromDate = fromDate.filter((item) => {
            return item.displayText === (fromDateMonth + ' ' + yearSelected);
        })

        const toDateOptions = getToDateOptionsWithMaxDate(tempFromDate?.[0]?.['displayText'], maxDateObject);
        setExImToDates(toDateOptions);
        
        const defaultToDateOption = toDateOptions.filter(item=>item.displayText==DEFAULT_TO_DATE)
        if(defaultToDateOption && defaultToDateOption.length>0) {
            tempToDate = defaultToDateOption;
        } else {
            tempToDate = [toDateOptions[toDateOptions.length-1]];
        }

        setToDateExImSelected(tempToDate); 
        localStorage.setItem('toDateSelected_exIm', JSON.stringify(tempToDate))

        setFromDateExImSelected(tempFromDate);
        
        localStorage.setItem('fromDateSelected_exIm', JSON.stringify(tempFromDate))

        
        const index = fromDate.findIndex((item) => item.displayText === tempToDate[0]?.displayText);
        if (index !== -1) {
            const tempFromDates = fromDate.slice(0, index + 1);
            setExImFromDates(tempFromDates);
        }
    }
    /* istanbul ignore next */
    const onChart1FiltersReset = () => {
        resetMonths()
        loadExImKPIPageDataPart1()

    }
    /* istanbul ignore next */
    const onChart2FiltersReset = () => {
        
        setExportingCountryExImSelected(exportingExImCountries)
        localStorage.setItem('expCountrySelected_exIm', JSON.stringify(exportingExImCountries))
        setExportingYearExImSelected(exportingExImYears)
        localStorage.setItem('expYearSelected_exIm', JSON.stringify(exportingExImYears))

        setImportingCountryExImSelected(exImimportingCountries)
        localStorage.setItem('impCountrySelected_exIm', JSON.stringify(exImimportingCountries))
        setImportingExImYearSelected(importingExImYears)
        localStorage.setItem('impYearSelected_exIm', JSON.stringify(importingExImYears))
        loadExImKPIPageDataPart2()
    }

    /* istanbul ignore next */
    const onMainFiltersReset = () => {
        
        localStorage.setItem('exim_reset_in_progress',1)
        resetMonths()
        onCategoryLevel0ExImChange(allCategoryL0)
    }
    // End ExIm --------------------------------------------------------
    /* istanbul ignore next */
    const onFiltersReset = () => {
        
        const maxDateForApps = [primaryDropdownData?.dateInfo];
        let capabilitySearchKey = "IMARC";
        const maxDateObject = maxDateForApps?.find(item => item?.appName === capabilitySearchKey);

        let maxYearMonth = maxDateObject?.maxYearMonth; // Example: "OCT 2024"
        let minYearMonth = maxDateObject?.minYearMonth; // Example: "OCT 2024"
        let maxYearValue;
        let minYearValue;
    
        if (maxYearMonth) {
            const [maxMonthText, maxYearText] = maxYearMonth.split(" ");
            maxYearValue = parseInt(maxYearText, 10);
        }
        if (minYearMonth) {
            const [minMonthText, minYearText] = minYearMonth.split(" ");
            minYearValue = parseInt(minYearText, 10);
        }
        let yearsArray = [];
        for (let i = minYearValue; i <= maxYearValue; i++) {
            yearsArray.push(i);
        }

        const allYears = getYears(yearsArray);
        const maxYr = allYears[allYears.length - 1]?.displayText;
        const minYr = allYears[0]?.displayText;

        const minYear = Number(minYr);
        const maxYear = Number(maxYr);

        setEntireMonthList(getMonthsWithYearRangeAdjustedForMaxDate(minYear, maxYear, capabilitySearchKey, maxDateForApps));
        
        const fromDate = getMonthsWithYearWithMaxDate(allYears, maxDateObject);
        setFromDates(fromDate);

        let objectYear = Number(maxDateObject?.maxDate?.split("-")[0]); // Extracting year from maxDate
        const yearSelected = (objectYear-1); // DEFAULT_FROM_DATE_YEAR // defaultYear;

        const date2 = new Date();
        const date2Year = date2.getFullYear();

        // const fromDateMonth = 'Jan';
        const fromDateMonth = (maxDateObject?.minYearMonth?.split(" ")?.[0]);
        
        const tempFromDate = fromDate.filter((item) => {
            return item.displayText === (fromDateMonth + ' ' + yearSelected);
        })
        
        let tempToDate = fromDate.filter((item) => {
            let temp = fromDate[fromDate.length - 1]?.displayText;

            let currentLastMonth = Number(yearSelected) < objectYear
                ? "Dec " + yearSelected
                : maxYearMonth;

            return item.displayText.toUpperCase() === currentLastMonth.toUpperCase();
        });

        const toDateOptions = getToDateOptionsWithMaxDate(tempFromDate?.[0]?.['displayText'], maxDateObject);
        setToDates(toDateOptions);
            
        const defaultToDateOption = toDateOptions.filter(item=>item.displayText==DEFAULT_TO_DATE)
        if(defaultToDateOption && defaultToDateOption.length>0) {
            tempToDate = defaultToDateOption;
        } else {
            tempToDate = [toDateOptions[toDateOptions.length-1]]
        }

        setFromDateSelected(tempFromDate);
        
        localStorage.setItem('fromDateSelected_imarc', JSON.stringify(tempFromDate))

        setToDateSelected(tempToDate); 
        localStorage.setItem('toDateSelected_imarc', JSON.stringify(tempToDate))
        const index = fromDate.findIndex((item) => item.displayText === tempToDate[0]?.displayText);
        if (index !== -1) {
            const tempFromDates = fromDate.slice(0, index + 1);
            setFromDates(tempFromDates);
        }

        onMaterialChange(allMaterials);

    }
    /* istanbul ignore next */
    const conditionalLegend = switcherIndex == 0 
        ? { name: "Overall Value (USD, MN)", color: "#B05788" }
        : { name: "Price per MT (USD/MT)", color: "#B05788" };

    const lineChartLegends = [
        {
            "name": "Volume",
            "color": "#33ABDA"
        },
        conditionalLegend
    ]

    

    /* istanbul ignore next */
	if(authState?.isAuthenticated){
		return(
			
                <>

                    {
                        selectedTab == 1 ? (
                            <>
                                <CommodityPageHeader header={"Export-Import Trade Analytics"}
                                    subtext={"Explore the Export-Import Trade Analytics and Insights across our Commodities and Key Markets."}
                                    image={ExImBanner}
                                    refreshFrequency={imarcData?.refreshFrequency || "-"}
                                    lastUpdated={imarcData?.lastUpdate || "-"}
                                />
                                <Row gutter={[10, 10]} justify="start" style={{ width: "100%", marginTop:"24px" }}>
                                    <Col flex="1">
                                        <SingleSelectDropdown placeholder="View" className='buy-con-dropdown-modal' label="View" childList={roleSelected} selectedValue={roleSelected} setSelectedValue={{}} disabled={true} />
                                    </Col>
                                    <Col flex="1">
                                        <SingleSelectDropdown placeholder="Categories L0" className='buy-con-dropdown-modal' label="Category L0" childList={categoryL0Selected} selectedValue={categoryL0Selected} setSelectedValue={{}} disabled={true} />
                                    </Col>
                                    <Col flex="1">
                                        <SingleSelectDropdown placeholder={"Categories L1"} className='buy-con-dropdown-modal' label={"Category L1"} childList={categoryL1Selected} selectedValue={categoryL1Selected} setSelectedValue={{}} disabled={true} />
                                    </Col>
                                    <Col flex="1">
                                        <SingleSelectDropdown
                                            className='buy-con-dropdown-modal'
                                            label={"From Date"}
                                            childList={fromDates}
                                            selectedValue={fromDateSelected}
                                            setSelectedValue={onFromDateChange}
                                        />
                                    </Col>
                                    <Col flex="1">
                                            <SingleSelectDropdown className='buy-con-dropdown-modal' 
                                                label="To Date" 
                                                childList={toDates} 
                                                selectedValue={toDateSelected} 
                                                setSelectedValue={onToDateChange}
                                                />
                                    </Col>
                                </Row>
                            </>
                        ) : (
                            <>
                                <CommodityPageHeader header={"Export-Import Trade Analytics"}
                                    subtext={"Explore the Export-Import Trade Analytics and Insights across our Commodities and Key Markets."}
                                    image={ExImBanner}
                                    refreshFrequency={exImMonthlyData?.refreshFrequency || "-"}
                                    lastUpdated={exImMonthlyData?.lastUpdate || "-"}
                                />
                                <Row gutter={[10, 10]} justify="start" style={{ width: "100%", marginTop:"24px" }}>
                                    <Col flex="1">
                                        <SingleSelectDropdown placeholder="View" className='buy-con-dropdown-modal' label="View" childList={roleExImSelected} selectedValue={roleExImSelected} setSelectedValue={{}} disabled={true} />
                                    </Col>
                                    <Col flex="1"> 
                                        <MultiSelectDropdown placeholder="Categories L0" className='buy-con-dropdown-modal' label="Category L0" childList={categoriesExImLevel0} selectedValue={categoryL0ExImSelected} setSelectedValue={onCategoryLevel0ExImChange} />
                                    </Col>
                                    <Col flex="1"> 
                                        <MultiSelectDropdown placeholder="Categories L1" className='buy-con-dropdown-modal' label="Category L1" childList={categoriesExImLevel1} selectedValue={categoryL1ExImSelected} setSelectedValue={onCategoryLevel1ExImChange} />
                                    </Col>
                                    <Col flex="1"> 
                                        <MultiSelectDropdown placeholder="Categories L2" className='buy-con-dropdown-modal' label="Category L2" childList={categoriesExImLevel2} selectedValue={categoryL2ExImSelected} setSelectedValue={onCategoryLevel2ExImChange} />
                                    </Col>
                                </Row>

                                <Row justify="end">
                                    <button className="reset-button" onClick={onMainFiltersReset}  style={{ marginTop: '12px', marginRight:'0.8rem' }}>
                                        <img src={reset_icon} className="reset_icon" alt="Reset Icon" />
                                        <span>Reset Filters</span>
                                    </button>
                                </Row>

                  
                            </>
                        )
                    }

                    

                    <br/>

                    <Row justify={"start"} style={{ width: "100%", position: 'relative' }}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <div style={{width: '100%'}} className="ph-trade-page">

                                    
                                    <Card style={{ height: '100%', alignItems: 'flex-start', width: '100%'}} className="trade-analytics-full-card">
                                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop:"5px", width: '100%' }}>
                                        {/* <div style={{ width: '100%' }}> */}
                                                {/* <TabsNavigation className="ph-overview-nav" selectedIndex={selectedTab-1} style={{}} > */}
                                                {/* <Card> */}
                                                    <TabsNavigation  className="trend-analytics-tabs" selectedIndex={selectedTab-1} style={{width: '100% !important'}} >
                                                    {/* <TabsNavigation className="veridion-tabs" selectedIndex={selectedTab-1} style={{}} type="border"> */}
                                                        <Tab label="Markets: All | Categories: Packaging" iconTrailing={<div style={{ fontSize: '10px'}}>(powered by Procure 360 Dasboard by IMARC)</div>} onClick={function Xs(){setSelectedTab(1)}}/>
                                                        <Tab label="Markets: NA | Categories: All" iconTrailing={<div style={{ fontSize: '10px'}}>(powered by Ex-IM dashboard by Smartcube)</div>} onClick={function Xs(){setSelectedTab(2)}} />
                                                    </TabsNavigation>
                                                    
                                                {/* </Card> */}
                                        {/* </div> */}
                                    </div>

                                    

                                    {
                                        selectedTab == 1 ? (
                                            <>
                                                <div style={{display: 'flex', justifyContent: 'flex-start', width: '100%'}}>
                                                    <img src={Procure_Logo_360} />
                                                    <span className="procure-360-header" style={{marginLeft: '1rem'}}>Procure 360 Dashboard (powered by IMARC)</span>
                                                </div>

                                                <Row gutter={[10, 10]} justify="start" style={{ width: "100%", marginTop:"12px" }}>
                                                    <Col xs={24} sm={24} md={3} lg={3} xl={3}> 
                                                        <MultiSelectDropdown placeholder="Material" className='buy-con-dropdown-modal' label="Material" childList={materials} selectedValue={materialSelected} setSelectedValue={onMaterialChange}/>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={4} lg={4} xl={4}> 
                                                        <MultiSelectDropdown placeholder="Grade" className='buy-con-dropdown-modal' label="Grade" childList={grades} selectedValue={gradeSelected} setSelectedValue={onGradeChange}/>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={5} lg={5} xl={5}> 
                                                        <MultiSelectDropdown placeholder="Type" className='buy-con-dropdown-modal' label="Type" childList={materialTypes} selectedValue={materialTypeSelected} setSelectedValue={onMaterialTypeChange}/>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={3} lg={3} xl={3}> 
                                                        <MultiSelectDropdown placeholder="Trade Name" className='buy-con-dropdown-modal' label="Trade Name" childList={tradeNames} selectedValue={tradeNameSelected} setSelectedValue={onTradeNameChange}/>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={3} lg={3} xl={3}> 
                                                        <MultiSelectDropdown placeholder="Size" className='buy-con-dropdown-modal' label="Size" childList={sizeOptions} selectedValue={sizeOptionSelected} setSelectedValue={onSizeOptionChange}/>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={3} lg={3} xl={3}> 
                                                        <MultiSelectDropdown placeholder="Export Country" className='buy-con-dropdown-modal' label="Export Country" childList={exportingCountries} selectedValue={exportingCountrySelected} setSelectedValue={onExportCountryChange}/>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={3} lg={3} xl={3}> 
                                                        <MultiSelectDropdown placeholder="Import Country" className='buy-con-dropdown-modal' label="Import Country" childList={importingCountries} selectedValue={importingCountrySelected} setSelectedValue={onImportCountryChange}/>
                                                    </Col>
                                                </Row>
                                                <div style={{width: '100%'}}>
                                                    <Row justify="end">
                                                        <button className="reset-button" onClick={onFiltersReset}  style={{ marginTop: '12px', marginRight:'0.8rem', marginBottom: "24px" }}>
                                                            <img src={reset_icon} className="reset_icon" alt="Reset Icon" />
                                                            <span>Reset Filters</span>
                                                        </button>
                                                    </Row>
                                                </div>

                                                {
                                                    isDataLoading ? (
                                                        <>
                                                            <LoadingSpinner />
                                                        </>
                                                    ) : (
                                                        <>

                                                            <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                                                                <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                                                    <span className="trade-uom" >Unit of Measure:</span> 
                                                                    {/* <span className="trade-metric-tonnes" style={{ padding: '0 0.2rem'}}> Metric Tonnes</span> */}
                                                                    <span > 
                                                                        <Tag
                                                                            className=""
                                                                            color="orange"
                                                                            size="medium"
                                                                            style={{}}
                                                                            text="Metric Tonnes"
                                                                            type="default"
                                                                            state="default"
                                                                            isCopyable={false}
                                                                        />

                                                                    </span>
                                                                </span>
                                                                <span>
                                                                    <Button
                                                                        className="ph-imarc-sidebar"
                                                                        // iconTrailing={"arrow_forward"}
                                                                        size="medium"
                                                                        style={{color:"#034895", fontSize: '14px', marginRight: '10px'}}
                                                                        text="Show Resources"
                                                                        iconLeading={"keyboard_double_arrow_left"}
                                                                        variant="tertiary"
                                                                        onClick={function clickButton() {
                                                                            setShowSidePanel(true)
                                                                        }}
                                                                    />
                                                                </span>
                                                                
                                                            </div>


                                                

                                                            <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%", position: 'relative' }}>
                                                                                    <Col xs={24} sm={24} md={12} lg={24} xl={24}>
                                                                                        <div ref={TrendforVolumeandOverallValueRef}>
                                                                                        <Card style={{ height: '100%' }} className="archlet-chart-card">
                                                                                                <div style={{width: '100%'}}> 

                                                                                                                {
                                                                                                                    trendAnalyticsLineBarChartData && trendAnalyticsLineBarChartData?.length > 0 ? (
                                                                                                                                <>
                                                                                                                                    <div className="total-spend-xaxis-label"  style={{display: 'flex', justifyContent: 'space-between', marginBottom: '20px'}}>Trend for Volume and {switcherIndex == 0 ? 'Overall Value (USD, MN)' : 'Price per MT (USD/MT)'}
                                                                                                                                                <span style={{float: 'right'}}>
                                                                                                                                                        <DropdownWithIcons modalRef={TrendforVolumeandOverallValueRef} kpiName={switcherIndex == 0 ? "Trend for Volume and Overall Value (USD, MN)" : "Trend for Volume and Price per Unit (USD MT)"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                                                                                                                </span>
                                                                                                                                    </div>
                                                                                                                                    <div>

                                                                                                                                        <Switcher
                                                                                                                                                                                                className=""
                                                                                                                                                                                                items={[
                                                                                                                                                                                                    {
                                                                                                                                                                                                    label: 'Overall Value (USD, MN)',
                                                                                                                                                                                                    leadingIcon: 'edit',
                                                                                                                                                                                                    showLeadingIcon: false
                                                                                                                                                                                                    },
                                                                                                                                                                                                    {
                                                                                                                                                                                                    label: 'Price per MT (USD/MT)',
                                                                                                                                                                                                    leadingIcon: 'edit',
                                                                                                                                                                                                    showLeadingIcon: false
                                                                                                                                                                                                    }
                                                                                                                                                                                                ]}
                                                                                                                                                                                                selectedItemIndex={0}
                                                                                                                                                                                                onUpdate= {(val) => setSwitcherIndex(val)}
                                                                                                                                                                                                style={{}}
                                                                                                                                                                                        />                                                                                                                                    
                                                                                                                                    </div>
                                                                                                                                    <TrendAnalyticsLineBarChart tradeAnalyticsLineBarChartData={trendAnalyticsLineBarChartData} switcherIndex={switcherIndex} uom={''}/>
                                                                                                                                    <LegendList legends={lineChartLegends} style={{marginTop: '5px'}}/>
                                                                                                                                </>
                                                                                                                    ) : <NoData />
                                                                                                                }


                                                                                                        
                                                                                                        
                                                                                                </div>
                                                                                            </Card>
                                                                                        </div>
                                                                                    </Col>
                                                            </Row>
                                                    

                                                        
                                                            <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%", position: 'relative' }}>
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                    <div ref={VolumeSharebyExportCountryRef}>
                                                                                <Card style={{ height: '100%' }} className="archlet-chart-card">
                                                                                        {
                                                                                                volumeShareByExportingCountry && volumeShareByExportingCountry.length>0 ?
                                                                                                    <>
                                                                                                        <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                                                                                                            Volume (MT) Share by Export Country
                                                                                                            <span style={{float: 'right'}}>
                                                                                                                <DropdownWithIcons modalRef={VolumeSharebyExportCountryRef} kpiName={"Volume Share by Export Country"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        {
                                                                                                            <>
                                                                                                                <Row style={{ width: '100%', height: 75 }}>
                                                                                                                    <Col span={24}>
                                                                                                                        <div className="spend-stats-text">Total Volume</div>
                                                                                                                    </Col>
                                                                                                                
                                                                                                                    <Col span={24}>
                                                                                                                        <div style={{ display: 'flex', alignItems: 'flex-end' }}>   
                                                                                                                            {/* <div className="spend-stats-value">{getBNMNOrKValue(Number(imarcData?.volumeShareByExportingCountry?.totalVal)).replace('$', "")} </div>                                                          */}
                                                                                                                            <div className="spend-stats-value" style={{ fontSize: '25px' }}>{formatNumberWithCommas(splitValueWithUnit(getBNMNOrKValue(Number(imarcData?.volumeShareByExportingCountry?.totalVal)))['numericValue']).replace('$', "")}</div>
                                                                                                                            <div className="spend-stats-alpha" style={{ fontSize: '12px' }}>{splitValueWithUnit(getBNMNOrKValue(Number(imarcData?.volumeShareByExportingCountry?.totalVal)))['unit']}</div>
                                                                                                                        </div>
                                                                                                                    </Col>
                                                                                                                
                                                                                                                </Row>
                                                                                                                {/* <SpendDonutChart countryData={dummyDonutData} flag={multipleSectorFlagForL0Chart} isSpendChart={true} showInnerChart={l0InnerDonutFlag} /> */}
                                                                                                                <SpendDonutChart countryData={volumeShareByExportingCountry}  isTradeAnalyticsPage={true}/>
                                                                                                                {/* { 
                                                                                                                    l0ReconSpend!="1" && 
                                                                                                                    <div className="resiliency-legend-container">
                                                                                                                            Spend under reconciliation: 
                                                                                                                            <span style={{color: "#aa001a"}}>{l0ReconSpend}</span>
                                                                                                                    </div>
                                                                                                                } */}
                                                                                                                <br/>
                                                                                                                <LegendList legends={volumeShareByExportingCountryChartColors} />
                                                                                                            </>
                                                                                                        }
                                                                                                    </> :
                                                                                                        
                                                                                                        <NoData />
                                                                                        }
                                                                                </Card>
                                                                    </div>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                        <div ref={OverallValueSharebyExportCountryRef}>
                                                                                <Card style={{ height: '100%' }} className="archlet-chart-card">
                                                                                    {
                                                                                                usdShareByExportingCountry && usdShareByExportingCountry.length>0 ?
                                                                                                    <>
                                                                                                        <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                                                                                                            Overall Value (USD) Share by Export Country
                                                                                                            <span style={{float: 'right'}}>
                                                                                                                <DropdownWithIcons modalRef={OverallValueSharebyExportCountryRef} kpiName={"Overall Value Share by Export Country"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        {
                                                                                                            <>
                                                                                                                <Row style={{ width: '100%', height: 75 }}>
                                                                                                                    <Col span={24}>
                                                                                                                        <div className="spend-stats-text">Total Overall Value</div>
                                                                                                                    </Col>
                                                                                                                
                                                                                                                    <Col span={24}>
                                                                                                                        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                                                                                            <div className="spend-stats-value" style={{ fontSize: '25px' }}>{formatNumberWithCommas(splitValueWithUnit(imarcData?.usdShareByExportingCountry?.totalVal)['numericValue'])}</div>
                                                                                                                            <div className="spend-stats-alpha" style={{ fontSize: '12px' }}>{splitValueWithUnit(imarcData?.usdShareByExportingCountry?.totalVal)['unit']}</div>
                                                                                                                        </div>
                                                                                                                    </Col>
                                                                                                                
                                                                                                                </Row>
                                                                                                                {/* <SpendDonutChart countryData={dummyDonutData} flag={multipleSectorFlagForBUChart} isSpendChart={true} /> */}
                                                                                                                <SpendDonutChart countryData={usdShareByExportingCountry}  isSpendChart={true} isTradeAnalyticsPage={true}/>
                                                                                                                
                                                                                                                <br/>
                                                                                                                <LegendList legends={usdShareByExportingCountryChartColors} />
                                                                                                            </>
                                                                                                        }
                                                                                                    </>:
                                                                                                        
                                                                                                            <NoData />
                                                                                    }
                                                                                </Card>
                                                                        </div>
                                                                </Col>
                                                            </Row>

                                                            <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%", position: 'relative' }}>
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                    <div ref={VolumeSharebyImportCountryRef}>
                                                                                <Card style={{ height: '100%' }} className="archlet-chart-card">
                                                                                        {
                                                                                                volumeShareByImportingCountry && volumeShareByImportingCountry.length>0 ?
                                                                                                    <>
                                                                                                        <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                                                                                                            Volume (MT) Share by Import Country
                                                                                                            <span style={{float: 'right'}}>
                                                                                                                <DropdownWithIcons modalRef={VolumeSharebyImportCountryRef} kpiName={"Volume Share by Import Country"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        {
                                                                                                            <>
                                                                                                                <Row style={{ width: '100%', height: 75 }}>
                                                                                                                    <Col span={24}>
                                                                                                                        <div className="spend-stats-text">Total Volume</div>
                                                                                                                    </Col>
                                                                                                                
                                                                                                                    <Col span={24}>
                                                                                                                        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                                                                                            {/* <div className="spend-stats-value">{getBNMNOrKValue(Number(imarcData?.volumeShareByImportingCountry?.totalVal)).replace("$", "")} </div>  */}
                                                                                                                            <div className="spend-stats-value" style={{ fontSize: '25px' }}>{formatNumberWithCommas(splitValueWithUnit(getBNMNOrKValue(Number(imarcData?.volumeShareByImportingCountry?.totalVal)))['numericValue']).replace('$', "")}</div>
                                                                                                                            <div className="spend-stats-alpha" style={{ fontSize: '12px' }}>{splitValueWithUnit(getBNMNOrKValue(Number(imarcData?.volumeShareByExportingCountry?.totalVal)))['unit']}</div>
                                                                                                                        </div>
                                                                                                                    </Col>
                                                                                                                
                                                                                                                </Row>
                                                                                                                {/* <SpendDonutChart countryData={dummyDonutData} flag={multipleSectorFlagForL0Chart} isSpendChart={true} showInnerChart={l0InnerDonutFlag} /> */}
                                                                                                                <SpendDonutChart countryData={volumeShareByImportingCountry}  isTradeAnalyticsPage={true}/>
                                                                                                                {/* { 
                                                                                                                    l0ReconSpend!="1" && 
                                                                                                                    <div className="resiliency-legend-container">
                                                                                                                            Spend under reconciliation: 
                                                                                                                            <span style={{color: "#aa001a"}}>{l0ReconSpend}</span>
                                                                                                                    </div>
                                                                                                                } */}
                                                                                                                <br/>
                                                                                                                <LegendList legends={volumeShareByImportingCountryChartColors} />
                                                                                                            </>
                                                                                                        }
                                                                                                    </> :
                                                                                                        // l0ReconSpend!="1"?
                                                                                                        // <>
                                                                                                        //     <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>Spend Split by Direct (D)/Indirect (I)/Co-Man (C)</div>
                                                                                                        //     <NoData />
                                                                                                        //     <div className="resiliency-legend-container">
                                                                                                        //             Spend under reconciliation: 
                                                                                                        //             <span style={{color: "#aa001a"}}>{l0ReconSpend}</span>
                                                                                                        //     </div>
                                                                                                        // </> :
                                                                                                        <NoData />
                                                                                        }
                                                                                </Card>
                                                                    </div>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                        <div ref={OverallValueSharebyImportCountryRef}>
                                                                                <Card style={{ height: '100%' }} className="archlet-chart-card">
                                                                                    {
                                                                                                usdShareByImportingCountry && usdShareByImportingCountry?.length>0 ?
                                                                                                    <>
                                                                                                        <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                                                                                                            Overall Value (USD) Share by Import Country
                                                                                                            <span style={{float: 'right'}}>
                                                                                                                <DropdownWithIcons modalRef={OverallValueSharebyImportCountryRef} kpiName={"Overall Value Share by Import Country"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        {
                                                                                                            <>
                                                                                                                <Row style={{ width: '100%', height: 75 }}>
                                                                                                                    <Col span={24}>
                                                                                                                        <div className="spend-stats-text">Total Overall Value</div>
                                                                                                                    </Col>
                                                                                                                
                                                                                                                    <Col span={24}>
                                                                                                                        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                                                                                            <div className="spend-stats-value" style={{ fontSize: '25px' }}>{formatNumberWithCommas(splitValueWithUnit(imarcData?.usdShareByImportingCountry?.totalVal)['numericValue'])}</div>
                                                                                                                            <div className="spend-stats-alpha" style={{ fontSize: '12px' }}>{splitValueWithUnit(imarcData?.usdShareByImportingCountry?.totalVal)['unit']}</div>
                                                                                                                        </div>
                                                                                                                    </Col>
                                                                                                                
                                                                                                                </Row>
                                                                                                                {/* <SpendDonutChart countryData={dummyDonutData} flag={multipleSectorFlagForBUChart} isSpendChart={true} /> */}
                                                                                                                <SpendDonutChart countryData={usdShareByImportingCountry}  isSpendChart={true} isTradeAnalyticsPage={true}/>
                                                                                                                
                                                                                                                <br/>
                                                                                                                <LegendList legends={usdShareByImportingCountryChartColors} />
                                                                                                            </>
                                                                                                        }
                                                                                                    </>:
                                                                                                        
                                                                                                            <NoData />
                                                                                    }
                                                                                </Card>
                                                                        </div>
                                                                </Col>
                                                            </Row>

                                                        </>
                                                    )
                                                
                                                }

                                            </>
                                        ) : (
                                            <>
                                                {
                                                    isExImDataLoading ? (
                                                        <LoadingSpinner />
                                                    ) : (
                                                        <>
                                                            
                                                            
                                                            {/* <Row gutter={[10, 10]} justify="start" style={{ width: "100%", marginTop:"12px" }}>
                                                                <Col flex="1">
                                                                    <SingleSelectDropdown
                                                                        className='buy-con-dropdown-modal'
                                                                        label={"From Month"}
                                                                        childList={exImfromDates}
                                                                        selectedValue={fromDateExImSelected}
                                                                        setSelectedValue={onFromDateExImChange}
                                                                    />
                                                                </Col>
                                                                <Col flex="1">
                                                                        <SingleSelectDropdown className='buy-con-dropdown-modal' 
                                                                            label="To Month" 
                                                                            childList={exImtoDates} 
                                                                            selectedValue={toDateExImSelected} 
                                                                            setSelectedValue={onToDateExImChange}
                                                                            />
                                                                </Col>
                                                            </Row> */}

                                                            

                                                <>
                                                    <div style={{display: 'flex', justifyContent: 'flex-start', width: '100%'}}>
                                                        <img src={ExImLogo} />
                                                        <span className="procure-360-header" style={{marginLeft: '1rem'}}>Ex-Im Dashboard (powered by SMARTCUBE)</span>
                                                    </div>
    
                                                    <div style={{display: 'flex', justifyContent: 'flex-start', width: '100%'}}>
                                                       {/* { exImswitcherIndex == 0 ? (
                                                        <>
                                                            <span className="exIm-filtermode-header">Filter Mode: </span><span className="exIm-filter-subtext"> Select a filter mode to begin exploring the data</span>
                                                        </>
                                                       ) : (
                                                        <>
                                                            <div>
                                                                <span className="exIm-filtermode-header">Filter Mode: </span>
                                                            </div>
                                                            
                                                            <div>
                                                                <span className="exIm-filter-subtext"> Use the Filter Mode dropdown to select how you want to view the chart. Each selection also updates the “HS Code Description” link below, where you can hover over the info icon <br/>to see details specific to your chosen filter.</span>
                                                            </div>
                                                        </>
                                                       )
                                                       }  */}
                                                       {/* //Select a filter mode(Product Description and HS Code) to begin exploring the data */}

                                                       <span className="exIm-filtermode-header">Filter Mode: </span><span className="exIm-filter-subtext"> Select a filter mode(Product Description and HS Code) to begin exploring the data</span>
                                                        
                                                    </div>
                                                    <Row gutter={[10, 10]} justify="start" style={{ width: "100%", marginTop:"12px" }}>
                        
                                                                {
                                                                    primaryDropdownExImData?.type==="SUCCESS_EXIM_DROPDOWN_ACTION" && 
                                                                    <div style={{  width:"100%" }}>
                                                                        <Switcher
                                                                            className=""
                                                                            items={[
                                                                                {
                                                                                label: 'Product Description',
                                                                                },
                                                                                {
                                                                                label: 'HS Code',
                                                                                },
                                                                            ]}
                                                                            selectedItemIndex={exImswitcherIndex}
                                                                            onUpdate= {(val) => {
                                                                                exImSwitchTabs(val)
                                                                            }}
                                                                            style={{}}
                                                                        />
                                                                    </div>
                                                                }
                                                                
                                                                {
                                                                    exImswitcherIndex === 1 &&
                                                                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                                        <SingleSelectDropdown placeholder="HS Code" className='buy-con-dropdown-modal risi-dropdown' label="HS Code" childList={hsCodes} selectedValue={hsCodeSelected} setSelectedValue={onHSCodeChange} />
                                                                    </Col>
                                                                }
                                                                {
                                                                    exImswitcherIndex === 0 &&
                                                                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                                        <SingleSelectDropdown placeholder="Product Description" className='buy-con-dropdown-modal risi-dropdown' label="Product Description" childList={productDescriptions} selectedValue={productDescriptionSelected} setSelectedValue={onDescriptionChange} />
                                                                    </Col>
                                                                }
                                                    </Row>
                                                    {
                                                        // exImswitcherIndex == 1 ? (
                                                            <div style={{width: '100%', display: 'flex', justifyContent: 'flex-start'}} className="exIm-hscode-text">
                                                                {/* <span>HS Code Description Updated 
                                                                    <span style={{margin:'8px', color: 'black'}}>
                                                                        <Tooltip text={
                                                                            <>
                                                                                <div style={{ fontWeight: 700 }} >HS CODE DESCRIPTION:</div>
                                                                                <div>{`Based on ITC Trade Map. ${currentTooltipText}`} </div>
                                                                            </>
                                                                        }  >
                                                                            <Icon alt="" icon="info" size="small" />
                                                                        </Tooltip>
                                                                    </span>
                                                                    
                                                                </span> */}
                                                                <Notification
                                                                    className="exim-hscode-notification"
                                                                    primaryActionLabel=""
                                                                    primaryActionOnClick={function ERe(){}}
                                                                    secondaryActionLabel=""
                                                                    secondaryActionOnClick={function ERe(){}}
                                                                    showActionButtons
                                                                    showIcon
                                                                    showText
                                                                    style={{}}
                                                                    text={
                                                                            <span><b>HS Code Description based on ITC Trade Map:</b>
                                                                            {` ${currentTooltipText}`}
                                                                            </span>
                                                                    }
                                                                    title=""
                                                                    type="info"
                                                                    />
                                                            </div>
                                                        // ) : <></>
                                                    }
                                                    
    
                                                    {/* <Row gutter={[10, 10]} justify="start" style={{ width: "100%", marginTop:"12px" }}>
                                                        <Col xs={24} sm={24} md={3} lg={3} xl={3}> 
                                                            <MultiSelectDropdown placeholder="Material" className='buy-con-dropdown-modal' label="Material" childList={materials} selectedValue={materialSelected} setSelectedValue={onMaterialChange}/>
                                                        </Col>
                                                        <Col xs={24} sm={24} md={4} lg={4} xl={4}> 
                                                            <MultiSelectDropdown placeholder="Grade" className='buy-con-dropdown-modal' label="Grade" childList={grades} selectedValue={gradeSelected} setSelectedValue={onGradeChange}/>
                                                        </Col>
                                                        <Col xs={24} sm={24} md={5} lg={5} xl={5}> 
                                                            <MultiSelectDropdown placeholder="Type" className='buy-con-dropdown-modal' label="Type" childList={materialTypes} selectedValue={materialTypeSelected} setSelectedValue={onMaterialTypeChange}/>
                                                        </Col>
                                                        <Col xs={24} sm={24} md={3} lg={3} xl={3}> 
                                                            <MultiSelectDropdown placeholder="Trade Name" className='buy-con-dropdown-modal' label="Trade Name" childList={tradeNames} selectedValue={tradeNameSelected} setSelectedValue={onTradeNameChange}/>
                                                        </Col>
                                                        <Col xs={24} sm={24} md={3} lg={3} xl={3}> 
                                                            <MultiSelectDropdown placeholder="Size" className='buy-con-dropdown-modal' label="Size" childList={sizeOptions} selectedValue={sizeOptionSelected} setSelectedValue={onSizeOptionChange}/>
                                                        </Col>
                                                        <Col xs={24} sm={24} md={3} lg={3} xl={3}> 
                                                            <MultiSelectDropdown placeholder="Export Country" className='buy-con-dropdown-modal' label="Export Country" childList={exportingExImCountries} selectedValue={exportingCountryExImSelected} setSelectedValue={onExportCountryExImChange}/>
                                                        </Col>
                                                        <Col xs={24} sm={24} md={3} lg={3} xl={3}> 
                                                            <MultiSelectDropdown placeholder="Import Country" className='buy-con-dropdown-modal' label="Import Country" childList={exImimportingCountries} selectedValue={importingCountryExImSelected} setSelectedValue={onImportCountryExImChange}/>
                                                        </Col>
                                                    </Row> */}
                                                    {/* <div style={{width: '100%'}}>
                                                        <Row justify="end">
                                                            <button className="reset-button" onClick={onFiltersReset}  style={{ marginTop: '12px', marginRight:'0.8rem', marginBottom: "24px" }}>
                                                                <img src={reset_icon} className="reset_icon" alt="Reset Icon" />
                                                                <span>Reset Filters</span>
                                                            </button>
                                                        </Row>
                                                    </div> */}
    
                                                    {
                                                        isExImDataLoading ? ( ////////////////////////////////// To be changed
                                                            <>
                                                                <LoadingSpinner />
                                                            </>
                                                        ) : (
                                                            <>
    
                                                                <div style={{display: 'flex', justifyContent: 'flex-end', width: '100%'}}>
                                                                    
                                                                    <span>
                                                                        <Button
                                                                            className="ph-imarc-sidebar"
                                                                            // iconTrailing={"arrow_forward"}
                                                                            size="medium"
                                                                            style={{color:"#034895", fontSize: '14px', marginRight: '10px'}}
                                                                            text="Show Resources"
                                                                            iconLeading={"keyboard_double_arrow_left"}
                                                                            variant="tertiary"
                                                                            onClick={function clickButton() {                                                                               
                                                                                setShowExImSidePanel(true)
                                                                            }}
                                                                        />
                                                                    </span>
                                                                    
                                                                </div>
    
    
                                                    
    
                                                                <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%", position: 'relative' }}>
                                                                                        <Col xs={24} sm={24} md={12} lg={24} xl={24}>
                                                                                            <div ref={exImMonthTrendforVolumeandOverallValueRef}>
                                                                                            <Card style={{ height: '100%',border: '1px solid #D8E7FB', borderRadius: '10px' }} className="archlet-chart-card">
                                                                                                    <div style={{width: '100%'}}>
                                                                                                    <div className="total-spend-xaxis-label"  style={{display: 'flex', justifyContent: 'space-between', marginBottom: '20px'}}>Monthly Global Trend for Volume ({exImMonthlyData?.unit}) and {exIMswitcherLineBarChartIndex == 0 ? 'Overall Value (USD, MN) of Imports by NA' : `Price per ${exImMonthlyData?.unit} (USD/${exImMonthlyData?.unit}) of Imports by NA`}
                                                                                                                                                    <span style={{float: 'right'}}>
                                                                                                                                                            <DropdownWithIcons modalRef={exImMonthTrendforVolumeandOverallValueRef} 
                                                                                                                                                                kpiName={exIMswitcherLineBarChartIndex == 0 ? `Monthly Global Trend for Volume(${exImMonthlyData?.unit}) and Overall Value (USD, MN) of Imports by NA` : `Monthly Global Trend for Volume(${exImMonthlyData?.unit}) and Price per ${exImMonthlyData?.unit} (USD ${exImMonthlyData?.unit}) of Imports by NA`} 
                                                                                                                                                                checkPDFDownloaded={checkPDFDownloaded}/>
                                                                                                                                                    </span>
                                                                                                    </div>
                                                                                                    <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
    
                                                                                                        <span>
                                                                                                            <Switcher
                                                                                                                                                                    className=""
                                                                                                                                                                    items={[
                                                                                                                                                                        {
                                                                                                                                                                        label: 'Overall Value (USD, MN)',
                                                                                                                                                                        leadingIcon: 'edit',
                                                                                                                                                                        showLeadingIcon: false
                                                                                                                                                                        },
                                                                                                                                                                        {
                                                                                                                                                                        label: `Price per ${exImMonthlyData?.unit} (USD/${exImMonthlyData?.unit})`,
                                                                                                                                                                        leadingIcon: 'edit',
                                                                                                                                                                        showLeadingIcon: false
                                                                                                                                                                        }
                                                                                                                                                                    ]}
                                                                                                                                                                    selectedItemIndex={0}
                                                                                                                                                                    onUpdate= {(val) => setExIMswitcherLineBarChartIndex(val)}
                                                                                                                                                                    style={{}}
                                                                                                                                                            />    
                                                                                                        </span>

                                                                                                        <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                                                                                            <Row gutter={[10, 10]} justify="start" style={{ width: "100%"}}>
                                                                                                                <Col flex="1">
                                                                                                                    <SingleSelectDropdown
                                                                                                                        className='buy-con-dropdown-modal'
                                                                                                                        label={"From Month"}
                                                                                                                        childList={exImfromDates}
                                                                                                                        selectedValue={fromDateExImSelected}
                                                                                                                        setSelectedValue={onFromDateExImChange}
                                                                                                                    />
                                                                                                                </Col>
                                                                                                                <Col flex="1">
                                                                                                                        <SingleSelectDropdown className='buy-con-dropdown-modal' 
                                                                                                                            label="To Month" 
                                                                                                                            childList={exImtoDates} 
                                                                                                                            selectedValue={toDateExImSelected} 
                                                                                                                            setSelectedValue={onToDateExImChange}
                                                                                                                            />
                                                                                                                </Col>
                                                                                                                <Col flex="1">
                                                                                                                    <button className="reset-button" onClick={onChart1FiltersReset}  style={{ marginTop: '20px', marginRight:'0.8rem', marginBottom: "24px" }}>
                                                                                                                        <img src={reset_icon} className="reset_icon" alt="Reset Icon" />
                                                                                                                        <span>Reset Filters</span>
                                                                                                                    </button>
                                                                                                                </Col>
                                                                                                            </Row>

                                                                                                            {/* <Row justify="end">
                                                                                                                <button className="reset-button" onClick={onChart1FiltersReset}  style={{ marginTop: '12px', marginRight:'0.8rem', marginBottom: "24px" }}>
                                                                                                                    <img src={reset_icon} className="reset_icon" alt="Reset Icon" />
                                                                                                                    <span>Reset Filters</span>
                                                                                                                </button>
                                                                                                            </Row> */}
                                                                                                            <br/>
                                                                                                        </span>

                                                                                                        <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                                                                                            <span className="trade-uom" >Unit of Measure:</span> 
                                                                                                            {/* <span className="trade-metric-tonnes" style={{ padding: '0 0.2rem'}}> {exImdata?.unit} </span> */}
                                                                                                            <span > 
                                                                                                                <Tag
                                                                                                                    className=""
                                                                                                                    color="orange"
                                                                                                                    size="medium"
                                                                                                                    style={{}}
                                                                                                                    text={exImMonthlyData?.unit}
                                                                                                                    type="default"
                                                                                                                    state="default"
                                                                                                                    isCopyable={false}
                                                                                                                />

                                                                                                            </span>
                                                                                                        </span>                                                                                                                                
                                                                                                    </div>
                                                                                                    <div>
                                                                                                                { 
                                                                                                                        
                                                                                                                        exImMonthtrendAnalyticsLineBarChartData && exImMonthtrendAnalyticsLineBarChartData?.length > 0 ? (
                                                                                                                                    <>
                                                                                                                                        
                                                                                                                                        {isExImMonthPart1DataLoading ? (
                                                                                                                                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}> <LoadingSpinner /> </div>
                                                                                                                                            ) : (
                                                                                                                                                <>
                                                                                                                                                    <TrendAnalyticsLineBarChart tradeAnalyticsLineBarChartData={exImMonthtrendAnalyticsLineBarChartData} switcherIndex={exIMswitcherLineBarChartIndex} uom={exImMonthlyData?.unit} isExImChart={true}/>
                                                                                                                                                    <LegendList legends={exIMlineChartLegends} style={{marginTop: '5px'}}/>
                                                                                                                                                </>
                                                                                                                                            )
                                                                                                                                            }
                                                                                                                                        
                                                                                                                                    </>
                                                                                                                        ) : <NoData />
                                                                                                                    }

                                                                                                    </div>
    
                                                                                                                    
    
    
                                                                                                            
                                                                                                            
                                                                                                    </div>
                                                                                                </Card>
                                                                                            </div>
                                                                                        </Col>
                                                                </Row>
                                                        
                                                                <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%", position: 'relative' }}>
                                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                        <Card style={{ height: '100%', alignItems: 'flex-start', width: '100% !important', border: '1px solid #D8E7FB', borderRadius: '10px'}} className={"exIm-year-country-card"}>
                                                                            <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                                                                                Export/Import from NA to other countries: Analysis by Volume and Value
                                                                            </div>  
                                                                            <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                                                                <span>
                                                                                    {/* <Switcher
                                                                                        className=""
                                                                                                                                                                                                        items={[
                                                                                                                                                                                                            {
                                                                                                                                                                                                            label: 'Export Trade',
                                                                                                                                                                                                            leadingIcon: 'edit',
                                                                                                                                                                                                            showLeadingIcon: false
                                                                                                                                                                                                            },
                                                                                                                                                                                                            {
                                                                                                                                                                                                            label: 'Import Trade',
                                                                                                                                                                                                            leadingIcon: 'edit',
                                                                                                                                                                                                            showLeadingIcon: false
                                                                                                                                                                                                            }
                                                                                                                                                                                                        ]}
                                                                                                                                                                                                        selectedItemIndex={0}
                                                                                                                                                                                                        onUpdate= {(val) => setExIMswitcherPieChartIndex(val)}
                                                                                                                                                                                                        style={{}}
                                                                                                                                                                                                                                                                                    />                                     */}
                                                                                    <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}>
                                                                                        {
                                                                                            secondaryDropdownExImData?.type==="SUCCESS_EXIM_COUNTRY_DROPDOWN_ACTION" && 
                                                                                            <div style={{ width:"100%" }}>
                                                                                                <Switcher
                                                                                                    className=""
                                                                                                    items={[
                                                                                                        {
                                                                                                        label: 'Export Trade',
                                                                                                        },
                                                                                                        {
                                                                                                        label: 'Import Trade',
                                                                                                        },
                                                                                                    ]}
                                                                                                    selectedItemIndex={countryexImSwitcherIndex}
                                                                                                    onUpdate= {(val) => {
                                                                                                        exImSwitchCountryTabs(val)
                                                                                                    }}
                                                                                                    style={{}}
                                                                                                />
                                                                                            </div>
                                                                                        }
                                                                                        {/* {
                                                                                            countryexImSwitcherIndex===0 && 
                                                                                            <>
                                                                                                <Col flex="1"> 
                                                                                                    <MultiSelectDropdown placeholder="Country" className='buy-con-dropdown-modal' label="Country" childList={exportingExImCountries} selectedValue={exportingCountryExImSelected} setSelectedValue={onExportCountryExImChange} />
                                                                                                </Col>
                                                                                                <Col flex="1"> 
                                                                                                    <MultiSelectDropdown placeholder="Year" className='buy-con-dropdown-modal' label="Year" childList={exportingExImYears} selectedValue={exportingYearExImSelected} setSelectedValue={onExportYearExImChange} />
                                                                                                </Col>
                                                                                            </>
                                                                                        }
                                                                                        
                                                                                        {
                                                                                            countryexImSwitcherIndex===1 && 
                                                                                            <>
                                                                                                <Col flex="1">
                                                                                                    <MultiSelectDropdown placeholder="Country" className='buy-con-dropdown-modal' label="Country" childList={exImimportingCountries} selectedValue={importingCountryExImSelected} setSelectedValue={onImportCountryExImChange} />
                                                                                                </Col>
                                                                                                <Col flex="1"> 
                                                                                                    <MultiSelectDropdown placeholder="Year" className='buy-con-dropdown-modal' label="Year" childList={importingExImYears} selectedValue={importingExImYearSelected} setSelectedValue={onImportYearExImChange} />
                                                                                                </Col>
                                                                                            </>
                                                                                        } */}

                                                                                    </Row>
                                                                                </span>
                                                                                {/* <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                                                                    <span className="trade-uom" >Unit of Measure:</span> 
                                                                                    <span className="trade-metric-tonnes" style={{ padding: '0 0.2rem'}}> Metric Tonnes</span>
                                                                                </span> */}
                                                                                <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                                                                    <Row gutter={[10, 10]} justify="start" style={{ width: "100%"}}>
                                                                                            {
                                                                                                countryexImSwitcherIndex===0 && 
                                                                                                <>
                                                                                                    <Col flex="1"> 
                                                                                                        <MultiSelectDropdown placeholder="Country" className='buy-con-dropdown-modal' label="Country" childList={exportingExImCountries} selectedValue={exportingCountryExImSelected} setSelectedValue={onExportCountryExImChange} />
                                                                                                    </Col>
                                                                                                    <Col flex="1"> 
                                                                                                        <MultiSelectDropdown placeholder="Year" className='buy-con-dropdown-modal' label="Year" childList={exportingExImYears} selectedValue={exportingYearExImSelected} setSelectedValue={onExportYearExImChange} />
                                                                                                    </Col>
                                                                                                    <Col flex="1"> 
                                                                                                        <button className="reset-button" onClick={onChart2FiltersReset}  style={{ marginTop: '22px', marginRight:'0.8rem', marginBottom: "24px" }}>
                                                                                                            <img src={reset_icon} className="reset_icon" alt="Reset Icon" />
                                                                                                            <span>Reset Filters</span>
                                                                                                        </button>
                                                                                                    </Col>
                                                                                                </>
                                                                                            }
                                                                                            
                                                                                            {
                                                                                                countryexImSwitcherIndex===1 && 
                                                                                                <>
                                                                                                    <Col flex="1">
                                                                                                        <MultiSelectDropdown placeholder="Country" className='buy-con-dropdown-modal' label="Country" childList={exImimportingCountries} selectedValue={importingCountryExImSelected} setSelectedValue={onImportCountryExImChange} />
                                                                                                    </Col>
                                                                                                    <Col flex="1"> 
                                                                                                        <MultiSelectDropdown placeholder="Year" className='buy-con-dropdown-modal' label="Year" childList={importingExImYears} selectedValue={importingExImYearSelected} setSelectedValue={onImportYearExImChange} />
                                                                                                    </Col>
                                                                                                    <Col flex="1"> 
                                                                                                        <button className="reset-button" onClick={onChart2FiltersReset}  style={{ marginTop: '22px', marginRight:'0.8rem', marginBottom: "24px" }}>
                                                                                                            <img src={reset_icon} className="reset_icon" alt="Reset Icon" />
                                                                                                            <span>Reset Filters</span>
                                                                                                        </button>
                                                                                                    </Col>
                                                                                                </>
                                                                                            }
                                                                                    </Row>

                                                                                    {/* <Row justify="end">
                                                                                        <button className="reset-button" onClick={onChart2FiltersReset}  style={{ marginTop: '12px', marginRight:'0.8rem', marginBottom: "24px" }}>
                                                                                            <img src={reset_icon} className="reset_icon" alt="Reset Icon" />
                                                                                            <span>Reset Filters</span>
                                                                                        </button>
                                                                                    </Row> */}
                                                                                </span>
                                                                                <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                                                                    <span className="trade-uom" >Unit of Measure:</span> 
                                                                                    <span > 
                                                                                        <Tag
                                                                                                                                                        className=""
                                                                                                                                                        color="orange"
                                                                                                                                                        size="medium"
                                                                                                                                                        style={{}}
                                                                                                                                                        text={exImCountryData?.unit}
                                                                                                                                                        type="default"
                                                                                                                                                        state="default"
                                                                                                                                                        isCopyable={false}
                                                                                        />
    
                                                                                    </span>
                                                                                </span>
                                                                            </div>     
                                                                            {
                                                                                isExImYearPart2DataLoading ? (
                                                                                    <LoadingSpinner />
                                                                                ) : (
                                                                                    <>
                                                                                        <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%", position: 'relative' }}>
                                                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                                                <div ref={exImVolumeSharebyExportCountryRef} style={{marginRight: '10px'}}>
                                                                                                            {/* <Card style={{ height: '100%' }} className="archlet-chart-card"> */}
                                                                                                                    {
                                                                                                                            exImvolumeShareByCountry && exImvolumeShareByCountry.length>0 ?
                                                                                                                                <>
                                                                                                                                    <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                                                                                                                                        Volume ({exImCountryData?.unit}) Share of {countryexImSwitcherIndex == 0? 'Exports' : 'Imports'} by NA
                                                                                                                                        <span style={{float: 'right'}}>
                                                                                                                                            <DropdownWithIcons modalRef={exImVolumeSharebyExportCountryRef} kpiName={countryexImSwitcherIndex == 0? 'Volume Share ('+exImCountryData?.unit+') of Exports by NA' : 'Volume Share ('+exImCountryData?.unit+') of Imports by NA'} checkPDFDownloaded={checkPDFDownloaded}/>
                                                                                                                                        </span>
                                                                                                                                    </div>
                                                                                                                                    {
                                                                                                                                        <>
                                                                                                                                            <Row style={{ width: '100%', height: 75 }}>
                                                                                                                                                <Col span={24}>
                                                                                                                                                    <div className="spend-stats-text">Total Volume</div>
                                                                                                                                                </Col>
                                                                                                                                            
                                                                                                                                                <Col span={24}>
                                                                                                                                                    <div style={{ display: 'flex', alignItems: 'flex-end' }}>                                                                                                                              
                                                                                                                                                        <div className="spend-stats-value" style={{ fontSize: '25px' }}>{formatNumberWithCommas(splitValueWithUnit(getBNMNOrKValue(Number(exImCountryData?.volumeShareByCountry?.totalVal)))['numericValue']).replace('$', "")}</div>
                                                                                                                                                        <div className="spend-stats-alpha" style={{ fontSize: '12px' }}>{splitValueWithUnit(getBNMNOrKValue(Number(exImCountryData?.volumeShareByCountry?.totalVal)))['unit']}</div>
                                                                                                                                                    </div>
                                                                                                                                                </Col>
                                                                                                                                            
                                                                                                                                            </Row>
    
                                                                                                                                            <SpendDonutChart countryData={exImvolumeShareByCountry}  isTradeAnalyticsPage={true}/>
                                                                                                                                            
                                                                                                                                            <br/>
                                                                                                                                            <LegendList legends={exImvolumeShareByCountryChartColors} />
                                                                                                                                        </>
                                                                                                                                    }
                                                                                                                                </> :
                                                                                                                                    <NoData />
                                                                                                                    }
                                                                                                            {/* </Card> */}
                                                                                                </div>
                                                                                            </Col>
                                                                                            {/* <Col xs={24} sm={24} md={1} lg={1} xl={1}></Col> */}
                                                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                                                    <div ref={exImOverallValueSharebyExportCountryRef} style={{marginLeft: '10px'}}>
                                                                                                            {/* <Card style={{ height: '100%' }} className="archlet-chart-card"> */}
                                                                                                                {
                                                                                                                            exImusdShareByCountry && exImusdShareByCountry?.length>0 ?
                                                                                                                                <>
                                                                                                                                    <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                                                                                                                                        Overall Value (USD, MN) Share of {countryexImSwitcherIndex == 0? 'Exports' : 'Imports'} by NA
                                                                                                                                        <span style={{float: 'right'}}>
                                                                                                                                            <DropdownWithIcons modalRef={exImOverallValueSharebyExportCountryRef} kpiName={countryexImSwitcherIndex == 0? 'Overall Value (USD, MN) Share of Exports by NA' : 'Overall Value (USD, MN) Share of Imports by NA'} checkPDFDownloaded={checkPDFDownloaded}/>
                                                                                                                                        </span>
                                                                                                                                    </div>
                                                                                                                                    {
                                                                                                                                        <>
                                                                                                                                            <Row style={{ width: '100%', height: 75 }}>
                                                                                                                                                <Col span={24}>
                                                                                                                                                    <div className="spend-stats-text">Total Overall Value</div>
                                                                                                                                                </Col>
                                                                                                                                            
                                                                                                                                                <Col span={24}>
                                                                                                                                                    <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                                                                                                                        <div className="spend-stats-value" style={{ fontSize: '25px' }}>{formatNumberWithCommas(splitValueWithUnit(exImCountryData?.usdShareByCountry?.totalVal)['numericValue'])}</div>
                                                                                                                                                        <div className="spend-stats-alpha" style={{ fontSize: '12px' }}>{splitValueWithUnit(exImCountryData?.usdShareByCountry?.totalVal)['unit']}</div>
                                                                                                                                                    </div>
                                                                                                                                                </Col>
                                                                                                                                            
                                                                                                                                            </Row>
                                                                                                                                            {/* <SpendDonutChart countryData={dummyDonutData} flag={multipleSectorFlagForBUChart} isSpendChart={true} /> */}
                                                                                                                                            <SpendDonutChart countryData={exImusdShareByCountry}  isSpendChart={true} isTradeAnalyticsPage={true}/>
                                                                                                                                            
                                                                                                                                            <br/>
                                                                                                                                            <LegendList legends={exImusdShareByCountryChartColors} />
                                                                                                                                        </>
                                                                                                                                    }
                                                                                                                                </>:
                                                                                                                                    
                                                                                                                                        <NoData />
                                                                                                                }
                                                                                                            {/* </Card> */}
                                                                                                    </div>
                                                                                            </Col>
                                                                                        
                                                                                        </Row>
                                                                                                       
                                                                              
    
                                                                                        <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%", position: 'relative' }}>
                                                                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                                            <div ref={exImYearTrendforVolumeandOverallValueRef}>
                                                                                                    {/* <Card style={{ height: '100%' }} className="archlet-chart-card"> */}
                                                                                                            <div style={{width: '100%'}}> 
            
                                                                                                                            {
                                                                                                                                exImYeartrendAnalyticsLineBarChartData && exImYeartrendAnalyticsLineBarChartData?.length > 0 ? (
                                                                                                                                            <>
                                                                                                                                                <div className="total-spend-xaxis-label"  style={{display: 'flex', justifyContent: 'space-between', marginBottom: '20px'}}>
                                                                                                                                                            Yearly Trend for Volume ({exImCountryData?.unit}) and {exIMswitcherByCountryLineBarChartIndex == 0 ? 'Overall Value (USD, MN)' : `Price per ${exImCountryData?.unit} (USD/${exImCountryData?.unit})`} of {countryexImSwitcherIndex == 0? 'Exports' : 'Imports'} by NA
                                                                                                                                                            <span style={{float: 'right'}}>
                                                                                                                                                            <DropdownWithIcons
                                                                                                                                                                modalRef={exImYearTrendforVolumeandOverallValueRef}
                                                                                                                                                                kpiName={`Yearly Trend for Volume (${exImCountryData?.unit}) and ${exIMswitcherByCountryLineBarChartIndex === 0 ? 'Overall Value (USD, MN)' : `Price per ${exImCountryData?.unit} (USD ${exImCountryData?.unit})`} of ${countryexImSwitcherIndex === 0 ? 'Exports' : 'Imports'} by NA`}
                                                                                                                                                                checkPDFDownloaded={checkPDFDownloaded} 
                                                                                                                                                            />
                                                                                                                                                            </span>
                                                                                                                                                </div>
                                                                                                                                                <div>
            
                                                                                                                                                    <Switcher
                                                                                                                                                                                                            className=""
                                                                                                                                                                                                            items={[
                                                                                                                                                                                                                {
                                                                                                                                                                                                                label: 'Overall Value (USD, MN)',
                                                                                                                                                                                                                leadingIcon: 'edit',
                                                                                                                                                                                                                showLeadingIcon: false
                                                                                                                                                                                                                },
                                                                                                                                                                                                                {
                                                                                                                                                                                                                label: `Price per ${exImCountryData?.unit} (USD/${exImCountryData?.unit})`,
                                                                                                                                                                                                                leadingIcon: 'edit',
                                                                                                                                                                                                                showLeadingIcon: false
                                                                                                                                                                                                                }
                                                                                                                                                                                                            ]}
                                                                                                                                                                                                            selectedItemIndex={0}
                                                                                                                                                                                                            onUpdate= {(val) => setExIMswitcherByCountryLineBarChart(val)}
                                                                                                                                                                                                            style={{}}
                                                                                                                                                                                                    />                                                                                                                                    
                                                                                                                                                </div>
                                                                                                                                                <TrendAnalyticsLineBarChart tradeAnalyticsLineBarChartData={exImYeartrendAnalyticsLineBarChartData} switcherIndex={exIMswitcherByCountryLineBarChartIndex} isYearExImChart={true} uom={exImCountryData?.unit} isExImChart={true}/>
                                                                                                                                                <LegendList legends={exIMByCountrylineChartLegends} style={{marginTop: '5px'}}/>
                                                                                                                                            </>
                                                                                                                                ) : <NoData />
                                                                                                                            }
            
            
                                                                                                                    
                                                                                                                    
                                                                                                            </div>
                                                                                                        {/* </Card> */}
                                                                                                    </div>
                                                                                            </Col>
                                                                                        
                                                                                        </Row>
                                                                                    </>
                                                                                )
                                                                            }
                                                                                
                                                                        </Card>
                                                                    </Col>
                                                                </Row>
    
                                                            </>
                                                        )
                                                    
                                                    }
    
                                                </>
                                                        </>
                                                    )
                                                } 
                                            </>
                                            
                                        )
                                    }
                                    

                                    


                                    
                                    </Card>
                                    </div>
                                    </Col> 
                                    
                    </Row>
                  
                    
 
                    <br/>
                    <br/>
                    {
                        selectedTab == 1 ? (
                            <>
                                <div className="spend-modal-manage-spend" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", width: '100%' }}>
                                    {
                                        imarcData?.owners?.length > 0 &&
                                        <div style={{width: '100%'}}>Please reach out to {imarcData?.owners?.map((contact, index) => (
                                            <React.Fragment key={index}>
                                                <a href={`mailto:${contact.emailId}`} style={{ color: "#005cbc", textDecoration: "None" }}>{contact.emailId}</a>
                                                {index < imarcData?.owners?.length - 1 && ', '}
                                            </React.Fragment>
                                        ))} for any query on the data displayed.</div>
                                    }
                                    <div style={{width: '100%'}}>Please fill in <a href={feedbackFormUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>this form</a> for any feedback related to Procurement Hub.</div>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="spend-modal-manage-spend" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", width: '100%' }}>
                                    {
                                        exImMonthlyData?.appOwners?.length > 0 &&
                                        <div style={{width: '100%'}}>Please reach out to {exImMonthlyData?.appOwners?.map((contact, index) => (
                                            <React.Fragment key={index}>
                                                <a href={`mailto:${contact.emailId}`} style={{ color: "#005cbc", textDecoration: "None" }}>{contact.emailId}</a>
                                                {index < exImMonthlyData?.appOwners?.length - 1 && ', '}
                                            </React.Fragment>
                                        ))} for any query on the data displayed.</div>
                                    }
                                    <div style={{width: '100%'}}>Please fill in <a href={feedbackFormUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>this form</a> for any feedback related to Procurement Hub.</div>
                                </div>
                            </>
                        )
                    }
                    

                    <div>

                    {
                        showSidePanel && (
                                <>
                                    <Sidepanel
                                        className="trade-analytics-sidepanel"
                                        linkProps={{
                                        iconLeading: '',
                                        iconTrailing: 'arrow_forward',
                                        label: 'Link',
                                        onClick: function C$e(){},
                                        size: 'medium'
                                        }}
                                        onCloseSidePanel={()=> setShowSidePanel(false)}
                                        primaryButtonProps={{
                                        onClick: function C$e(){},
                                        size: 'medium',
                                        text: 'Button',
                                        variant: 'primary'
                                        }}
                                        secondaryButtonProps={{
                                        onClick: function C$e(){},
                                        size: 'medium',
                                        text: 'Button',
                                        variant: 'secondary'
                                        }}
                                        showFooter={false}
                                        showLink
                                        showSidePanel={true}
                                        showSecondaryButton
                                        showTertiaryButton
                                        style={{}}
                                        tertiaryButtonProps={{
                                        onClick: function C$e(){},
                                        size: 'medium',
                                        text: 'Button',
                                        variant: 'tertiary'
                                        }}
                                        // title="Resources"
                                        type="vertical"
                                        verticalSidepanelHeight="400px"
                                    >
                                        <TradAnalyticsSidePanel responseData={imarcData} page={"Procure360"}/>
                                    </Sidepanel>
                                </>
                            )
                        }
                    </div>
                    <div>
                    {
                            showExImSidePanel && (
                                <>
                                    <Sidepanel
                                        className="trade-analytics-sidepanel"
                                        linkProps={{
                                        iconLeading: '',
                                        iconTrailing: 'arrow_forward',
                                        label: 'Link',
                                        onClick: function C$e(){},
                                        size: 'medium'
                                        }}
                                        onCloseSidePanel={()=> setShowExImSidePanel(false)}
                                        primaryButtonProps={{
                                        onClick: function C$e(){},
                                        size: 'medium',
                                        text: 'Button',
                                        variant: 'primary'
                                        }}
                                        secondaryButtonProps={{
                                        onClick: function C$e(){},
                                        size: 'medium',
                                        text: 'Button',
                                        variant: 'secondary'
                                        }}
                                        showFooter={false}
                                        showLink
                                        showSidePanel={true}
                                        showSecondaryButton
                                        showTertiaryButton
                                        style={{}}
                                        tertiaryButtonProps={{
                                        onClick: function C$e(){},
                                        size: 'medium',
                                        text: 'Button',
                                        variant: 'tertiary'
                                        }}
                                        // title="Resources"
                                        type="vertical"
                                        verticalSidepanelHeight="400px"
                                    >
                                        <TradAnalyticsSidePanel responseData={exImMonthlyData} page={"ExIM"}/>
                                    </Sidepanel>
                                </>
                            )
                        }
                    </div>
                </>
		)
	}
}

export default TradeAnalyticsLanding;